
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dYU3e", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");


const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}



var $2GGOW = parcelRequire("2GGOW");

const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;


const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');




var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $0682584c931be143$export$bb4f02e6ef6f6e17)(error) || (0, $e2c1a953aef26c23$export$6ccdb59d3479f4f1)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__ }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $b5dd42974905c1cd$export$41bca9dc6871dd4e)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("fEmGS", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bFdYQ = parcelRequire("bFdYQ");


var $9KSP9 = parcelRequire("9KSP9");

const $064e27ddb8b91a45$var$queryObjectIds = new WeakMap();
let $064e27ddb8b91a45$var$nextQueryObjectId = 0;
const $064e27ddb8b91a45$export$439562f4dc4d003b = (0, $9KSP9.captureOptimisticInteropWrites);
function $064e27ddb8b91a45$export$4f74402be4cd52cd({ query: query, variables: variables, callerPackage: callerPackage, readPreviousData: readPreviousData, writePreviousData: writePreviousData, writeData: writeData }) {
    (0, $9KSP9.recordOptimisticInteropWrite)({
        getKey: ()=>$064e27ddb8b91a45$var$getOptimisticQueryWriteKey({
                query: query,
                variables: variables,
                callerPackage: callerPackage
            }),
        createRestore: ()=>{
            let previousData;
            try {
                // Prefer the narrow restore path when the previous query result is
                // readable. Replaying the old result through writeQueryInterop keeps
                // rollback scoped to the exact query the optimistic update touched.
                previousData = readPreviousData();
            } catch  {
                // Apollo Cache 1.x can throw for missing/partial query data. In that
                // case we still need rollback coverage, so fall back to a broader
                // cache snapshot instead of leaving the optimistic write untracked.
                return (0, $9KSP9.createCacheSnapshotRestore)();
            }
            if (previousData == null) // A null read means the optimistic write may create records or list
            // shape that did not previously exist. A whole-cache snapshot is the
            // safest rollback because there is no precise previous query result
            // to replay.
            return (0, $9KSP9.createCacheSnapshotRestore)();
            return ()=>{
                // Restore by going back through the original interop API rather than
                // mutating either cache directly. This preserves Apollo/Relay routing
                // and any normal write-side behavior owned by writeQueryInterop.
                writePreviousData(previousData);
            };
        },
        applyWrite: writeData
    });
}
// Produces a stable key for deduping repeated writes to the same query inside a
// single optimistic update. Relay artifacts do not expose a simple public cache
// key here, so object identity plus variables/caller package is the local key.
function $064e27ddb8b91a45$var$getOptimisticQueryWriteKey({ query: query, variables: variables, callerPackage: callerPackage }) {
    // Query artifacts are object identities at runtime. Use a WeakMap ID plus
    // variables/caller package so an optimistic mutation captures each query write
    // once without relying on Relay artifact internals.
    const queryObject = query;
    if (!$064e27ddb8b91a45$var$queryObjectIds.has(queryObject)) // Assign lazily so we do not retain artifact objects outside the WeakMap.
    $064e27ddb8b91a45$var$queryObjectIds.set(queryObject, $064e27ddb8b91a45$var$nextQueryObjectId++);
    return JSON.stringify({
        query: $064e27ddb8b91a45$var$queryObjectIds.get(queryObject),
        variables: variables ?? {},
        callerPackage: callerPackage ?? null
    });
}



var $l1uFv = parcelRequire("l1uFv");


var $2ItkX = parcelRequire("2ItkX");

function $52093bfafa102098$export$77bf2d076cc42a0e(record, fields, data, variables) {
    if (!record || !$52093bfafa102098$var$isObjectRecord(data)) return false;
    // Relay commitUpdate is not transactional. Preflight the selection tree before
    // writing so list rewrites that require Relay normalization fall through to
    // commitPayload instead of committing partial in-place updates.
    if (!$52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables)) return false;
    return $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables);
}
function $52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables) {
    for (const field of fields){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude && !$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'InlineFragment') {
            if (!$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) return false;
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords || fieldData.length !== existingRecords.length) return false;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    if (item == null) continue;
                    if (!$52093bfafa102098$var$isObjectRecord(item)) return false;
                    const existingRecord = existingRecords[index];
                    if (!existingRecord || $52093bfafa102098$var$hasDifferentRecordId(existingRecord, item)) return false;
                    if (!$52093bfafa102098$var$canWriteQueryFields(existingRecord, linkedField.selections, item, variables)) return false;
                }
                continue;
            }
            if (!$52093bfafa102098$var$isObjectRecord(fieldData)) return false;
            const linkedRecord = record.getLinkedRecord(fieldKey);
            if (!linkedRecord || $52093bfafa102098$var$hasDifferentRecordId(linkedRecord, fieldData)) return false;
            if (!$52093bfafa102098$var$canWriteQueryFields(linkedRecord, linkedField.selections, fieldData, variables)) return false;
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && !$52093bfafa102098$var$isRelaySetValue(scalarValue)) return false;
            continue;
        }
    }
    return true;
}
function $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables) {
    let didWrite = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Honour @include/@skip so conditional fields (e.g. userPreferences) get written.
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        } else if (field.kind === 'InlineFragment') didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                // Read plural fields with getLinkedRecords; the singular getter throws on
                // plural data. Missing/changed list records are handled by the commitPayload
                // fallback so this in-place path only updates known records.
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords) continue;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    const existingRecord = existingRecords[index];
                    if (existingRecord && $52093bfafa102098$var$isObjectRecord(item)) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(existingRecord, linkedField.selections, item, variables) || didWrite;
                }
            } else if ($52093bfafa102098$var$isObjectRecord(fieldData)) {
                const linkedRecord = record.getLinkedRecord(fieldKey);
                if (linkedRecord) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(linkedRecord, linkedField.selections, fieldData, variables) || didWrite;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && $52093bfafa102098$var$isRelaySetValue(scalarValue)) {
                record.setValue(scalarValue, (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
                didWrite = true;
            }
        }
    }
    return didWrite;
}
function $52093bfafa102098$var$getRecordIdFromData(data) {
    const id = data.id;
    return typeof id === 'string' || typeof id === 'number' ? String(id) : null;
}
function $52093bfafa102098$var$hasDifferentRecordId(record, data) {
    const id = $52093bfafa102098$var$getRecordIdFromData(data);
    return Boolean(id && record.getDataID() !== id);
}
function $52093bfafa102098$var$isObjectRecord(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
function $52093bfafa102098$var$isRelaySetValue(value) {
    if (Array.isArray(value)) // Relay scalar arrays can contain nulls, but undefined elements are not valid setValue payloads.
    return value.every((item)=>item !== undefined && $52093bfafa102098$var$isRelaySetValue(item));
    return value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
} /* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ 


function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__) ? 'relay' : 'apollo';
    // Relay optimistic mutation updates call this same interop write path. Capture
    // rollback state before the primary write, then let the normal query bridge
    // below mirror the optimistic write when the cache bridge experiments are on.
    (0, $064e27ddb8b91a45$export$4f74402be4cd52cd)({
        query: params.query,
        variables: params.variables,
        callerPackage: params.__callerPackage__,
        readPreviousData: ()=>(0, $l1uFv.readQueryInterop)({
                query: params.query,
                variables: params.variables,
                __callerPackage__: params.__callerPackage__
            }),
        writePreviousData: (data)=>$f0827a369f0dafa9$export$f97bd2548c77448c({
                ...params,
                data: data
            }),
        writeData: ()=>$f0827a369f0dafa9$export$f97bd2548c77448c(params)
    });
    const didWrite = source === 'relay' ? $f0827a369f0dafa9$var$writeQueryInteropRelay(params) : $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
    if (didWrite) (0, $bFdYQ.syncQueryCacheBridge)({
        source: source,
        query: params.query,
        variables: params.variables,
        data: params.data
    });
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    // Guard window for SSR; this only runs client-side.
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    const { query: query, data: data, variables: variables } = params;
    if (!relayEnv || !data) return false;
    let didWrite = false;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) didWrite = (0, $52093bfafa102098$export$77bf2d076cc42a0e)(root, queryFields, data, variables || {});
    });
    if (!didWrite) {
        // If no existing Relay records were updated, fall back to Relay's normal payload
        // write path. Invalid Relay artifacts should still throw here, preserving the
        // original writeQueryInterop failure behavior.
        const operation = (0, $3e6Uc.createOperationDescriptor)((0, $3e6Uc.getRequest)(query), variables ?? {});
        relayEnv.commitPayload(operation, data);
        didWrite = true;
    }
    return didWrite;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
    return true;
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $2ItkX = parcelRequire("2ItkX");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    // Guard window for SSR; this only runs client-side.
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) return null;
    const source = relayEnv.getStore().getSource();
    const rootRecord = source.get((0, $3e6Uc.ROOT_ID));
    if (!rootRecord) return null;
    const queryNode = params.query;
    const queryFields = queryNode?.operation?.selections;
    if (!queryFields) return null;
    const variables = params.variables ?? {};
    const result = $65c7b8940c778902$var$readFields(source, (0, $3e6Uc.ROOT_ID), queryFields, variables);
    return result && !result.missing ? result.data : null;
}
/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readFields(source, recordId, fields, variables) {
    const record = source.get(recordId);
    if (!record) return null;
    const data = {};
    let missing = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Handle @include/@skip directives with variables
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) {
                const conditionalData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
                if (conditionalData) {
                    Object.assign(data, conditionalData.data);
                    missing = conditionalData.missing || missing;
                } else missing = true;
            }
        } else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            const linkedRef = record[fieldKey];
            const readLinkedRecord = (linkedRecordId)=>{
                if (linkedRecordId == null) return null;
                const linkedData = $65c7b8940c778902$var$readFields(source, linkedRecordId, linkedField.selections, variables);
                if (!linkedData) {
                    missing = true;
                    return null;
                }
                missing = linkedData.missing || missing;
                return linkedData.data;
            };
            if (linkedField.plural) {
                // Relay stores plural refs in two shapes:
                //  - canonical: { __refs: ['id1', 'id2', ...] }
                //  - tolerated: [{ __ref: 'id1' }, { __ref: 'id2' }]
                if (linkedRef && typeof linkedRef === 'object' && !Array.isArray(linkedRef) && Array.isArray(linkedRef.__refs)) {
                    const refs = linkedRef.__refs;
                    data[responseKey] = refs.map(readLinkedRecord);
                } else if (Array.isArray(linkedRef)) data[responseKey] = linkedRef.map((ref)=>{
                    if (ref && typeof ref === 'object' && '__ref' in ref) return readLinkedRecord(ref.__ref);
                    if (ref != null) missing = true;
                    return null;
                });
                else if (linkedRef === null) data[responseKey] = null;
                else {
                    data[responseKey] = null;
                    missing = true;
                }
            } else if (linkedRef && typeof linkedRef === 'object' && '__ref' in linkedRef) data[responseKey] = readLinkedRecord(linkedRef.__ref);
            else if (linkedRef === null) data[responseKey] = null;
            else {
                data[responseKey] = null;
                missing = true;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables);
            const value = record[fieldKey];
            if (value === undefined) missing = true;
            else data[responseKey] = value;
        } else if (field.kind === 'InlineFragment') {
            // Process all inline fragment selections
            const inlineData = $65c7b8940c778902$var$readFields(source, recordId, field.selections, variables);
            if (inlineData) {
                Object.assign(data, inlineData.data);
                missing = inlineData.missing || missing;
            } else missing = true;
        }
    // Other selection kinds (e.g., FragmentSpread, ClientExtension) are ignored —
    // readQuery only needs to traverse what the query operation directly selects.
    }
    return {
        data: data,
        missing: missing
    };
}
/* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("eTj7Y", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

function $ad64c28d72223b67$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $kyRHQ !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}
module.exports["isSSR"] = $ad64c28d72223b67$export$48d7c418edadb60c;

});

parcelRegister("iu6m9", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");


var $7Rqpr = parcelRequire("7Rqpr");


var $8ihu7 = parcelRequire("8ihu7");

function $763ece530a70fe0e$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $8ihu7._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $7Rqpr.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $763ece530a70fe0e$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $8ihu7._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $8ihu7._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}
module.exports["editorExperiment"] = $763ece530a70fe0e$export$9b7cf3b74f250027;

});

parcelRegister("1bFdN", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0dd6cb40b6e9abe2$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0dd6cb40b6e9abe2$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0dd6cb40b6e9abe2$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0dd6cb40b6e9abe2$var$getValidCacheKeyFn(options);
        this._cacheMap = $0dd6cb40b6e9abe2$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0dd6cb40b6e9abe2$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0dd6cb40b6e9abe2$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$0dd6cb40b6e9abe2$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0dd6cb40b6e9abe2$var$enqueuePostPromiseJob = typeof $kyRHQ === 'object' && typeof $kyRHQ.nextTick === 'function' ? function(fn) {
    if (!$0dd6cb40b6e9abe2$var$resolvedPromise) $0dd6cb40b6e9abe2$var$resolvedPromise = Promise.resolve();
    $0dd6cb40b6e9abe2$var$resolvedPromise.then(function() {
        $kyRHQ.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0dd6cb40b6e9abe2$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0dd6cb40b6e9abe2$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0dd6cb40b6e9abe2$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0dd6cb40b6e9abe2$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0dd6cb40b6e9abe2$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0dd6cb40b6e9abe2$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0dd6cb40b6e9abe2$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0dd6cb40b6e9abe2$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0dd6cb40b6e9abe2$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $0dd6cb40b6e9abe2$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0dd6cb40b6e9abe2$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0dd6cb40b6e9abe2$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0dd6cb40b6e9abe2$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0dd6cb40b6e9abe2$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0dd6cb40b6e9abe2$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0dd6cb40b6e9abe2$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0dd6cb40b6e9abe2$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0dd6cb40b6e9abe2$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0dd6cb40b6e9abe2$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0dd6cb40b6e9abe2$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0dd6cb40b6e9abe2$var$DataLoader;

});

parcelRegister("9trs7", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});

parcelRegister("ibzAc", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("dwp40");
var $hzQni = parcelRequire("hzQni");
var $dwp40 = parcelRequire("dwp40");


var $fhsiz = parcelRequire("fhsiz");


var $fB3RY = parcelRequire("fB3RY");


var $40rXS = parcelRequire("40rXS");


var $eu2js = parcelRequire("eu2js");


var $aGYoD = parcelRequire("aGYoD");


var $dS4Ej = parcelRequire("dS4Ej");


var $cnv66 = parcelRequire("cnv66");





var $grxv4 = parcelRequire("grxv4");








var $khxnJ = parcelRequire("khxnJ");

const $e5c3071e2f8e19ea$var$defaultConcurrentDownloadLimit = 16;
const $e5c3071e2f8e19ea$var$backoffMaxDelayInMillis = 600;
const $e5c3071e2f8e19ea$var$defaultMaxRetriesOnNotFound = 2;
class $e5c3071e2f8e19ea$export$2e2bcd8739ae039 {
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $e5c3071e2f8e19ea$var$defaultMaxRetriesOnNotFound) {
        return (0, $khxnJ.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($e5c3071e2f8e19ea$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
    constructor(tokenManager, options){
        this.tokenManager = void 0;
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.concurrentDownloadLimit = void 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $e5c3071e2f8e19ea$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
}






var $9trs7 = parcelRequire("9trs7");

const $ad24ab98148a1e88$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $ad24ab98148a1e88$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $ad24ab98148a1e88$export$3850f566ce8d817a {
    loadEmoji(emoji, useAlt) {
        const representation = $ad24ab98148a1e88$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $40rXS.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($ad24ab98148a1e88$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        this.mediaImageLoader = void 0;
        (0, $fB3RY.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
}
const $ad24ab98148a1e88$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $ad24ab98148a1e88$var$maxImageSize = 10000;
class $ad24ab98148a1e88$export$b522858a3709f4c {
    loadEmoji(emoji, useAlt) {
        const representation = $ad24ab98148a1e88$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $40rXS.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $40rXS.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $40rXS.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $ad24ab98148a1e88$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $fB3RY.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
    constructor(mediaImageLoader){
        this.dataURLCache = void 0;
        this.mediaImageLoader = void 0;
        (0, $fB3RY.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $9trs7.LRUMap)($ad24ab98148a1e88$var$maxImageCached);
    }
}
class $ad24ab98148a1e88$export$2e2bcd8739ae039 {
    loadEmoji(emoji, useAlt) {
        const representation = $ad24ab98148a1e88$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $40rXS.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $40rXS.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $40rXS.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $ad24ab98148a1e88$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $ad24ab98148a1e88$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $ad24ab98148a1e88$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
    constructor(tokenManager){
        this.cache = void 0;
        this.waitingInitUrls = [];
        this.cacheLoading = void 0;
        this.mediaImageLoader = void 0;
        (0, $fB3RY.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $e5c3071e2f8e19ea$export$2e2bcd8739ae039)(tokenManager);
    }
}



var $jDv0c = parcelRequire("jDv0c");




const $cbcce9c3800b5f24$export$866c20c059277b6 = 30;
class $cbcce9c3800b5f24$export$2e2bcd8739ae039 {
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $cbcce9c3800b5f24$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $dwp40.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
    constructor(siteServiceConfig){
        this.siteServiceConfig = void 0;
        this.tokens = void 0;
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
}





const $56e19901b3b391e9$export$6f3a08dea02a7b2b = 0.95;
class $56e19901b3b391e9$export$2e2bcd8739ae039 {
    /**
   * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
   */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $40rXS.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $40rXS.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
   * Will load media emoji, returning a new EmojiDescription if, for example,
   * the URL has changed.
   */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $40rXS.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $40rXS.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $fB3RY.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $grxv4.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $56e19901b3b391e9$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $fB3RY.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
   * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
   * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
   * completes with failure then the Promise will resolve to false.
   */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $jDv0c.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $jDv0c.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $fB3RY.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
   * Calls to site-scoped EmojiResource to delete emoji
   * @param emoji media emoji to delete
   * @returns Promise.resolve() if success and Promise.reject() for failure
   */ deleteEmoji(emoji) {
        if (!(0, $40rXS.isMediaEmoji)(emoji) && !(0, $40rXS.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $dwp40.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
    constructor(siteServiceConfig, mediaApiToken){
        this.siteServiceConfig = void 0;
        // @ts-ignore: I am not being read from, should I be deleted???
        this.mediaApiToken = void 0;
        this.mediaEmojiCache = void 0;
        this.tokenManager = void 0;
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $dwp40.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $40rXS.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $jDv0c.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $40rXS.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $40rXS.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $cbcce9c3800b5f24$export$2e2bcd8739ae039)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $ad24ab98148a1e88$export$2e2bcd8739ae039)(this.tokenManager);
    }
}



var $7ZWaV = parcelRequire("7ZWaV");

function $04739c225d9762d7$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}


const $6bf2160f5e2ae4c6$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $6bf2160f5e2ae4c6$export$b5efafc6dd611ec5 extends (0, $hzQni.AbstractResource) {
    /**
   * Get the emoji provider from Emoji Resource
   * @returns Promise<EmojiProvider>
   */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $fB3RY.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $7ZWaV.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $fhsiz.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $7ZWaV.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $dS4Ej.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $7ZWaV.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $7ZWaV.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $fB3RY.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $dS4Ej.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $aGYoD.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $aGYoD.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $aGYoD.ProviderTypes).ATLASSIAN;
        return (0, $aGYoD.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $cnv66.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $56e19901b3b391e9$export$2e2bcd8739ae039)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $40rXS.isPromise)(done)) return done.then(()=>{
                    (0, $fB3RY.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $fB3RY.default)('Failed to prime siteEmojiResource');
                });
                else (0, $fB3RY.default)('Already primed siteEmojiResource');
            } else (0, $fB3RY.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $40rXS.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $fhsiz.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
   *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
   */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $40rXS.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $40rXS.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $40rXS.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $7ZWaV.ufoExperiences)['emoji-searched'].start();
        (0, $7ZWaV.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $7ZWaV.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    /**
   * Synchronously reads the emoji type from the local cache for the given emojiId.
   * Returns `undefined` when the emoji is not in the cache or no repository is initialised.
   * This is a pure cache read — no network requests are made.
   */ getCachedEmojiType(emojiId) {
        if (!this.isRepositoryAvailable(this.emojiRepository)) return undefined;
        const { id: id, shortName: shortName } = emojiId;
        if (id) {
            const emoji = this.emojiRepository.findById(id);
            if (emoji) return emoji.type;
        }
        if (shortName) {
            const result = this.emojiRepository.findByShortName(shortName);
            if (result && !('then' in result)) return result.type;
        }
        return undefined;
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
   * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
   * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
   * for the purposes of tracking the frequency of use.
   *
   * @param emoji The full description of the emoji to record usage for.
   */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $40rXS.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $dwp40.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $eu2js.default)('localStorage')) try {
            window.localStorage.setItem((0, $fhsiz.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
    constructor(config){
        super();
        this.recordConfig = void 0;
        this.emojiRepository = void 0;
        this.lastQuery = void 0;
        this.activeLoaders = 0;
        this.initialLoaders = 0;
        this.retries = new Map();
        this.siteEmojiResource = void 0;
        this.selectedTone = void 0;
        this.currentUser = void 0;
        this.isInitialised = false;
        this.fetchOnDemand = false;
        this.emojiResponses = void 0;
        this.emojiProviderConfig = void 0;
        this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        };
        this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        };
        this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        const rewriteEmojiGatewayPath = (url)=>url.replace('/gateway/api/emoji', '/gateway/api/elements/emoji');
        const stargateEmojiPathEnabled = (0, $dh538.fg)('use-elements-stargate-emoji-path');
        const singleEmojiApi = config.singleEmojiApi;
        const optimisticImageApi = config.optimisticImageApi;
        this.emojiProviderConfig = stargateEmojiPathEnabled ? {
            ...config,
            providers: config.providers.map((provider)=>({
                    ...provider,
                    url: rewriteEmojiGatewayPath(provider.url)
                })),
            singleEmojiApi: singleEmojiApi ? {
                ...singleEmojiApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(singleEmojiApi.getUrl(emojiId))
            } : undefined,
            optimisticImageApi: optimisticImageApi ? {
                ...optimisticImageApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(optimisticImageApi.getUrl(emojiId))
            } : undefined
        } : config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $eu2js.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
}
class $6bf2160f5e2ae4c6$export$2e2bcd8739ae039 extends $6bf2160f5e2ae4c6$export$b5efafc6dd611ec5 {
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 30000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $04739c225d9762d7$export$a9cd205a244d9f54)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
    constructor(config){
        super(config);
        this.allowUpload = void 0;
        this.allowUpload = !!config.allowUpload;
    }
}
module.exports["supportsUploadFeature"] = $6bf2160f5e2ae4c6$export$7b697b720032fd6f;
module.exports["default"] = $6bf2160f5e2ae4c6$export$2e2bcd8739ae039;

});

parcelRegister("dwp40", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("hzQni")).AbstractResource);
$parcel$export(module.exports, "utils", () => $1f71a8eb3bc012cd$export$eab97d15b1788b8d);
parcelRequire("eMprr");

parcelRequire("hzQni");

var $c8863f21f1f273cf$exports = {};

var $lMdlY = parcelRequire("lMdlY");


var $eMprr = parcelRequire("eMprr");

const $c6cbfff7952c4eb6$export$160dbda113bfad3b = {};
const $c6cbfff7952c4eb6$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $c6cbfff7952c4eb6$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $c6cbfff7952c4eb6$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $c6cbfff7952c4eb6$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $c6cbfff7952c4eb6$var$addToHeaders(headers, secOptions.headers);
    return headers;
};


const $c8863f21f1f273cf$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $c8863f21f1f273cf$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $c8863f21f1f273cf$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
const $c8863f21f1f273cf$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $c6cbfff7952c4eb6$export$160dbda113bfad3b);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $c6cbfff7952c4eb6$export$b5cd97dee32de81d)(url, path, queryParams, secOptions);
    const headers = (0, $c6cbfff7952c4eb6$export$7d6ed858a91629c3)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eMprr.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options?.reportTracingHeaders) {
            const tracingHeaders = $c8863f21f1f273cf$export$4f34edf253146101(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $c8863f21f1f273cf$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
$c8863f21f1f273cf$exports["extractTracingHeaders"] = $c8863f21f1f273cf$export$4f34edf253146101;
$c8863f21f1f273cf$exports["requestService"] = $c8863f21f1f273cf$export$97bfde5a702aaeca;


var $45f064c7ddd0f00a$exports = {};
var $cbd6dc458665296b$var$e = new TextDecoder;
async function $cbd6dc458665296b$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $cbd6dc458665296b$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}









const $45f064c7ddd0f00a$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $c6cbfff7952c4eb6$export$160dbda113bfad3b))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $c6cbfff7952c4eb6$export$b5cd97dee32de81d)(url, path, queryParams, secOptions);
    const headers = (0, $c6cbfff7952c4eb6$export$7d6ed858a91629c3)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eMprr.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $lMdlY.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $cbd6dc458665296b$export$74e0a034be2368c7)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $45f064c7ddd0f00a$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};
$45f064c7ddd0f00a$exports["requestServiceMultipart"] = $45f064c7ddd0f00a$export$8b13532c81e8ac89;


const $1f71a8eb3bc012cd$export$eab97d15b1788b8d = $c8863f21f1f273cf$exports;
const $1f71a8eb3bc012cd$export$3b4c04cf7dad0e50 = $45f064c7ddd0f00a$exports;

});

parcelRegister("fhsiz", function(module, exports) {
const $da233efa41505253$export$5e4e3d1c3e43156a = 'CUSTOM';
const $da233efa41505253$export$78ccdc4be403c468 = 'FREQUENT';
const $da233efa41505253$export$2c4b04c3aacdf1b3 = 'SITE';
const $da233efa41505253$export$1b0258512be88334 = 'SEARCH';
const $da233efa41505253$export$42b510423367f354 = 'USER_CUSTOM';
const $da233efa41505253$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $da233efa41505253$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $da233efa41505253$export$8ac325bfd32359b0 = 'data:';
const $da233efa41505253$export$a330961542edfe6f = 'delete-emoji';
const $da233efa41505253$export$1a817f1886276c6d = 100000;
const $da233efa41505253$export$2e7088017339c92 = 28;
const $da233efa41505253$export$4cb591b57c224c0 = 26;
const $da233efa41505253$export$b31a41e904161dc1 = 24;
const $da233efa41505253$export$7dd039b460c61389 = 22;
const $da233efa41505253$export$96ee6614460413a0 = 24.25;
const $da233efa41505253$export$103771a4cd74af90 = 22.25;
const $da233efa41505253$export$5cc2afcf38309ce9 = 20.25;
const $da233efa41505253$export$9a9984214a4bd724 = 18.25;
const $da233efa41505253$export$3f99ac31dc0406db = 20;
const $da233efa41505253$export$8efb414216030943 = 16.25;
const $da233efa41505253$export$4adebc94e462aea5 = 16;
const $da233efa41505253$export$d171dc12fee2b1da = 350;
const $da233efa41505253$export$c10ac8125a260041 = 80;
const $da233efa41505253$export$5248fb9e0cccc41f = 'medium';
const $da233efa41505253$export$94f75d625e7801d3 = 260;
const $da233efa41505253$export$7ed599d166d65aea = 295;
const $da233efa41505253$export$7722b8e9522021df = $da233efa41505253$export$7ed599d166d65aea - 58; // picker height - actions height
const $da233efa41505253$export$9f36457335d8859f = $da233efa41505253$export$7ed599d166d65aea - 102; // picker height - actions height - preview height
const $da233efa41505253$export$e218e5cb105a0e22 = 54;
const $da233efa41505253$export$e67f617938b111f1 = $da233efa41505253$export$7ed599d166d65aea + $da233efa41505253$export$e218e5cb105a0e22;
const $da233efa41505253$export$e394a0c530ae5631 = 'fabric.emoji';
const $da233efa41505253$export$79ee4ef84c545f8f = `${$da233efa41505253$export$e394a0c530ae5631}.selectedTone`;
const $da233efa41505253$export$ec5e3f6f684720d7 = `${$da233efa41505253$export$e394a0c530ae5631}.selectedProductivityColor`;
const $da233efa41505253$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $da233efa41505253$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $da233efa41505253$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $da233efa41505253$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $da233efa41505253$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $da233efa41505253$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $da233efa41505253$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $da233efa41505253$export$4f0ee90b28d6efc5 = 0;
const $da233efa41505253$export$9f7de4293d27f3aa = 50;
const $da233efa41505253$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $da233efa41505253$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $da233efa41505253$export$2829f3ec323f8ec0 = 8;
const $da233efa41505253$export$ce3a0e7d2d7d6ba2 = 5;
const $da233efa41505253$export$858e8dc100a97278 = 150;
const $da233efa41505253$export$83aab2ae64548423 = 20;
const $da233efa41505253$export$66cabad5e268b05e = 100;
module.exports["customCategory"] = $da233efa41505253$export$5e4e3d1c3e43156a;
module.exports["frequentCategory"] = $da233efa41505253$export$78ccdc4be403c468;
module.exports["searchCategory"] = $da233efa41505253$export$1b0258512be88334;
module.exports["yourUploadsCategory"] = $da233efa41505253$export$42b510423367f354;
module.exports["customTitle"] = $da233efa41505253$export$5d0f2d8ee50f86f5;
module.exports["userCustomTitle"] = $da233efa41505253$export$1debc2f10cc69389;
module.exports["dataURLPrefix"] = $da233efa41505253$export$8ac325bfd32359b0;
module.exports["deleteEmojiLabel"] = $da233efa41505253$export$a330961542edfe6f;
module.exports["MAX_ORDINAL"] = $da233efa41505253$export$1a817f1886276c6d;
module.exports["scaledEmojiHeightH1"] = $da233efa41505253$export$2e7088017339c92;
module.exports["scaledEmojiHeightH2"] = $da233efa41505253$export$4cb591b57c224c0;
module.exports["scaledEmojiHeightH3"] = $da233efa41505253$export$b31a41e904161dc1;
module.exports["scaledEmojiHeightH4"] = $da233efa41505253$export$7dd039b460c61389;
module.exports["denseEmojiHeightH1"] = $da233efa41505253$export$96ee6614460413a0;
module.exports["denseEmojiHeightH2"] = $da233efa41505253$export$103771a4cd74af90;
module.exports["denseEmojiHeightH3"] = $da233efa41505253$export$5cc2afcf38309ce9;
module.exports["denseEmojiHeightH4"] = $da233efa41505253$export$9a9984214a4bd724;
module.exports["defaultEmojiHeight"] = $da233efa41505253$export$3f99ac31dc0406db;
module.exports["defaultDenseEmojiHeight"] = $da233efa41505253$export$8efb414216030943;
module.exports["defaultInlineEmojiHeight"] = $da233efa41505253$export$4adebc94e462aea5;
module.exports["emojiPickerWidth"] = $da233efa41505253$export$d171dc12fee2b1da;
module.exports["sizeGap"] = $da233efa41505253$export$c10ac8125a260041;
module.exports["defaultEmojiPickerSize"] = $da233efa41505253$export$5248fb9e0cccc41f;
module.exports["emojiPickerHeight"] = $da233efa41505253$export$7ed599d166d65aea;
module.exports["emojiPickerListHeight"] = $da233efa41505253$export$7722b8e9522021df;
module.exports["emojiPickerListHeightNew"] = $da233efa41505253$export$9f36457335d8859f;
module.exports["emojiPickerPreviewHeight"] = $da233efa41505253$export$e218e5cb105a0e22;
module.exports["localStoragePrefix"] = $da233efa41505253$export$e394a0c530ae5631;
module.exports["selectedToneStorageKey"] = $da233efa41505253$export$79ee4ef84c545f8f;
module.exports["selectedProductivityColorStorageKey"] = $da233efa41505253$export$ec5e3f6f684720d7;
module.exports["defaultCategories"] = $da233efa41505253$export$d7ab74456f1aa1ad;
module.exports["KeyboardKeys"] = $da233efa41505253$export$70f9e5bc10d7eac;
module.exports["KeyboardNavigationDirection"] = $da233efa41505253$export$1c4f2adc1f8e19d3;
module.exports["CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED"] = $da233efa41505253$export$99130b698ea188ae;
module.exports["EMOJI_KEYBOARD_KEYS_SUPPORTED"] = $da233efa41505253$export$84b035f8d01101cc;
module.exports["TONESELECTOR_KEYBOARD_KEYS_SUPPORTED"] = $da233efa41505253$export$e27d4e477c0cd4ec;
module.exports["EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED"] = $da233efa41505253$export$97027974dc06eeee;
module.exports["DEFAULT_TONE"] = $da233efa41505253$export$4f0ee90b28d6efc5;
module.exports["EMOJI_LIST_COLUMNS"] = $da233efa41505253$export$2829f3ec323f8ec0;
module.exports["EMOJI_LIST_PAGE_COUNT"] = $da233efa41505253$export$ce3a0e7d2d7d6ba2;
module.exports["EMOJI_SEARCH_DEBOUNCE"] = $da233efa41505253$export$858e8dc100a97278;
module.exports["SAMPLING_RATE_EMOJI_RENDERED_EXP"] = $da233efa41505253$export$83aab2ae64548423;
module.exports["SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP"] = $da233efa41505253$export$66cabad5e268b05e;

});

parcelRegister("fB3RY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7041f489cd763bba$export$2e2bcd8739ae039);
let $7041f489cd763bba$var$debugEnabled = false;
let $7041f489cd763bba$var$stacktracesEnabled = false;
function $7041f489cd763bba$export$748ada60eaf985cc(enable) {
    $7041f489cd763bba$var$debugEnabled = enable;
}
function $7041f489cd763bba$export$4f7017086af31c25(enable) {
    $7041f489cd763bba$var$stacktracesEnabled = enable;
}
function $7041f489cd763bba$export$2a858f450a2f66d() {
    if ($7041f489cd763bba$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $7041f489cd763bba$export$2e2bcd8739ae039(msg, ...args) {
    if ($7041f489cd763bba$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("40rXS", function(module, exports) {

var $8Tx5v = parcelRequire("8Tx5v");


var $fhsiz = parcelRequire("fhsiz");

const $8f8213d5762be97c$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $8f8213d5762be97c$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $8f8213d5762be97c$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $8f8213d5762be97c$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $8f8213d5762be97c$export$607f0d89b8881fb4 = (rep)=>!!(rep && rep.unicodeEmoji);
const $8f8213d5762be97c$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $8f8213d5762be97c$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $8f8213d5762be97c$export$a7e82c67204c73a1 = (emoji)=>$8f8213d5762be97c$export$979133dc1df141c6(emoji.representation);
const $8f8213d5762be97c$export$7720a4954d6f75f8 = (rep)=>$8f8213d5762be97c$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $fhsiz.dataURLPrefix)) === 0;
const $8f8213d5762be97c$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $fhsiz.customCategory) && $8f8213d5762be97c$export$7720a4954d6f75f8(emoji.representation);
const $8f8213d5762be97c$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $8f8213d5762be97c$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $8f8213d5762be97c$export$dddfba07c16c94d2 = (key)=>key in (0, $8Tx5v.messages);
const $8f8213d5762be97c$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $8f8213d5762be97c$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $8f8213d5762be97c$export$8d7d3de6b5b305d1(emoji);
};
const $8f8213d5762be97c$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $8f8213d5762be97c$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($8f8213d5762be97c$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $8f8213d5762be97c$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $8f8213d5762be97c$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $8f8213d5762be97c$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$8f8213d5762be97c$export$979133dc1df141c6(mediaRepresentation) && !$8f8213d5762be97c$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $8f8213d5762be97c$export$979133dc1df141c6(mediaRepresentation) ? $8f8213d5762be97c$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $8f8213d5762be97c$export$979133dc1df141c6(mediaAltRepresentation) ? $8f8213d5762be97c$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $8f8213d5762be97c$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $8f8213d5762be97c$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $8f8213d5762be97c$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;
module.exports["isSpriteServiceRepresentation"] = $8f8213d5762be97c$export$1c52f72b88b558e8;
module.exports["isSpriteRepresentation"] = $8f8213d5762be97c$export$a194199d673d75de;
module.exports["isImageRepresentation"] = $8f8213d5762be97c$export$90b099a26fbd8b41;
module.exports["isMediaRepresentation"] = $8f8213d5762be97c$export$979133dc1df141c6;
module.exports["isUnicodeRepresentation"] = $8f8213d5762be97c$export$607f0d89b8881fb4;
module.exports["isPromise"] = $8f8213d5762be97c$export$4369c812aac99591;
module.exports["isEmojiDescription"] = $8f8213d5762be97c$export$378ed2c87d03531c;
module.exports["isMediaEmoji"] = $8f8213d5762be97c$export$a7e82c67204c73a1;
module.exports["isLoadedMediaEmoji"] = $8f8213d5762be97c$export$d25a80b2c86d7fdf;
module.exports["isEmojiDescriptionWithVariations"] = $8f8213d5762be97c$export$b0ed6d8df471f3cc;
module.exports["isEmojiVariationDescription"] = $8f8213d5762be97c$export$82a0350e1f6b5c0a;
module.exports["isMessagesKey"] = $8f8213d5762be97c$export$dddfba07c16c94d2;
module.exports["toEmojiId"] = $8f8213d5762be97c$export$8d7d3de6b5b305d1;
module.exports["containsEmojiId"] = $8f8213d5762be97c$export$39ed0ad389e58ef7;
module.exports["convertImageToMediaRepresentation"] = $8f8213d5762be97c$export$20a1bd1d33069ce7;
module.exports["convertMediaToImageEmoji"] = $8f8213d5762be97c$export$f1a89a11f425faaa;
module.exports["buildEmojiDescriptionWithAltRepresentation"] = $8f8213d5762be97c$export$a48c58c688a3131;
module.exports["getCategoryId"] = $8f8213d5762be97c$export$4bcbf61cb6832a8e;

});

parcelRegister("8Tx5v", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $359e221f768e8d0f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    deleteEmojiTooltip: {
        id: "fabric.emoji.delete.tooltip",
        defaultMessage: "Delete"
    },
    deleteEmojiTooltipForScreenreader: {
        id: "fabric.emoji.delete.screenreader.tooltip",
        defaultMessage: "To delete {shortName} emoji, press Backspace"
    },
    deleteEmojiTitle: {
        id: "fabric.emoji.delete.title",
        defaultMessage: "Remove emoji"
    },
    deleteEmojiDescription: {
        id: "fabric.emoji.delete.description",
        defaultMessage: "All existing instances of this emoji will be replaced with {emojiShortName}"
    },
    deleteEmojiLabel: {
        id: "fabric.emoji.delete.label",
        defaultMessage: "Remove"
    },
    addCustomEmojiLabel: {
        id: "fabric.emoji.add.custom.emoji.label",
        defaultMessage: "Add your own emoji"
    },
    emojiPlaceholder: {
        id: "fabric.emoji.placeholder",
        defaultMessage: "e.g. hello"
    },
    emojiNameAriaLabel: {
        id: "fabric.emoji.name.ariaLabel",
        defaultMessage: "Enter a name for the new emoji"
    },
    emojiNameLabel: {
        id: "fabric.emoji.name.label",
        defaultMessage: "Emoji name"
    },
    emojiChooseFileTitle: {
        id: "fabric.emoji.choose.file.title",
        defaultMessage: "Choose file"
    },
    emojiChooseFileDndTitle: {
        id: "fabric.emoji.choose.file.dnd.title",
        defaultMessage: "Select or drop an image"
    },
    emojiChooseFileScreenReaderDescription: {
        id: "fabric.emoji.choose.file.screenReaderDescription",
        defaultMessage: "Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB"
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: "fabric.emoji.select.skin.tone.ariaLabel",
        defaultMessage: "Choose your skin tone, {selectedTone} selected"
    },
    emojiSelectColorButtonAriaLabelText: {
        id: "fabric.emoji.select.color.ariaLabel",
        defaultMessage: "Productivity emoji color selector"
    },
    emojiSelectColorListAriaLabelText: {
        id: "fabric.emoji.select.color.list.ariaLabel",
        defaultMessage: "Productivity emoji colour selector"
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: "fabric.emoji.select.skin.list.ariaLabel",
        defaultMessage: "Skin tone selector"
    },
    emojiImageRequirements: {
        id: "fabric.emoji.image.requirements",
        defaultMessage: "JPG, PNG or GIF. Max size 1 MB."
    },
    emojiPreviewTitle: {
        id: "fabric.emoji.preview.title",
        defaultMessage: "Preview"
    },
    emojiPreview: {
        id: "fabric.emoji.preview",
        defaultMessage: "Your new emoji {emoji} looks great"
    },
    addEmojiLabel: {
        id: "fabric.emoji.add.label",
        defaultMessage: "Add emoji"
    },
    createEmojiWithRovoTitle: {
        id: "fabric.emoji.ai.create.title",
        defaultMessage: "Create an emoji with Rovo"
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: "fabric.emoji.ai.prompt.placeholder",
        defaultMessage: "Describe your emoji..."
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: "fabric.emoji.ai.prompt.ariaLabel",
        defaultMessage: "Describe the emoji you want to generate"
    },
    createEmojiWithRovoGenerateLabel: {
        id: "fabric.emoji.ai.generate.label",
        defaultMessage: "Generate"
    },
    createEmojiWithRovoError: {
        id: "fabric.emoji.ai.error",
        defaultMessage: "Something went wrong. Try a different description."
    },
    retryLabel: {
        id: "fabric.emoji.retry.label",
        defaultMessage: "Retry"
    },
    cancelLabel: {
        id: "fabric.emoji.cancel.label",
        defaultMessage: "Cancel"
    },
    searchPlaceholder: {
        id: "fabric.emoji.search.placeholder",
        defaultMessage: "Search"
    },
    searchLabel: {
        id: "fabric.emoji.search.label",
        defaultMessage: "Emoji name"
    },
    searchResultsStatus: {
        id: "fabric.emoji.search.status.count",
        defaultMessage: "Found {count} emojis"
    },
    searchResultsStatusSeeAll: {
        id: "fabric.emoji.search.status",
        defaultMessage: "Seeing all emojis"
    },
    categoriesSelectorLabel: {
        id: "fabric.emoji.categories.label",
        defaultMessage: "Choose an emoji category"
    },
    categoriesSearchResults: {
        id: "fabric.emoji.categories.search.results",
        defaultMessage: "Search results"
    },
    frequentCategory: {
        id: "fabric.emoji.category.frequent",
        defaultMessage: "Frequent"
    },
    peopleCategory: {
        id: "fabric.emoji.category.people",
        defaultMessage: "People"
    },
    natureCategory: {
        id: "fabric.emoji.category.nature",
        defaultMessage: "Nature"
    },
    foodsCategory: {
        id: "fabric.emoji.category.foods",
        defaultMessage: "Food & Drink"
    },
    activityCategory: {
        id: "fabric.emoji.category.activity",
        defaultMessage: "Activity"
    },
    placesCategory: {
        id: "fabric.emoji.category.places",
        defaultMessage: "Travel & Places"
    },
    objectsCategory: {
        id: "fabric.emoji.category.objects",
        defaultMessage: "Objects"
    },
    symbolsCategory: {
        id: "fabric.emoji.category.symbols",
        defaultMessage: "Symbols"
    },
    flagsCategory: {
        id: "fabric.emoji.category.flags",
        defaultMessage: "Flags"
    },
    productivityCategory: {
        id: "fabric.emoji.category.productivity",
        defaultMessage: "Atlassian & productivity"
    },
    userUploadsCustomCategory: {
        id: "fabric.emoji.category.user.uploads",
        defaultMessage: "Your uploads"
    },
    allUploadsCustomCategory: {
        id: "fabric.emoji.category.all.uploads",
        defaultMessage: "All uploads"
    },
    deleteEmojiFailed: {
        id: "fabric.emoji.error.delete.failed",
        defaultMessage: "Remove failed"
    },
    emojiInvalidImage: {
        id: "fabric.emoji.error.invalid.image",
        defaultMessage: "Selected image is invalid"
    },
    emojiUploadFailed: {
        id: "fabric.emoji.error.upload.failed",
        defaultMessage: "Upload failed"
    },
    emojiUploadTimeout: {
        id: "fabric.emoji.error.upload.timeout",
        defaultMessage: "Upload timed out"
    },
    emojiImageTooBig: {
        id: "fabric.emoji.error.image.too.big",
        defaultMessage: "Selected image is more than 1 MB"
    },
    emojiUnsupportedFileType: {
        id: "fabric.emoji.error.unsupported.file.type",
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji."
    },
    emojiDuplicateName: {
        id: "fabric.emoji.error.duplicate.name",
        defaultMessage: "An emoji with this name exists already"
    },
    emojiPickerNoResults: {
        id: "fabric.emoji.picker.no.results",
        defaultMessage: "No results"
    },
    emojiPickerAddCustomEmoji: {
        id: "fabric.emoji.picker.add.custom.emoji",
        defaultMessage: "Add custom emoji"
    },
    emojiPickerTitle: {
        id: "fabric.emoji.picker",
        defaultMessage: "Emoji picker"
    },
    emojiPickerListPanel: {
        id: "fabric.emoji.pickerlist.tabpanel",
        defaultMessage: "Emojis actions and list panel"
    },
    emojiPickerGrid: {
        id: "fabric.emoji.pickerlist.grid",
        defaultMessage: "{showSearchResults, select, true{Search results} other{Emojis}}"
    },
    emojiButtonRoleDescription: {
        id: "fabric.emoji.emojipicker.emoi.roledescription",
        defaultMessage: "emoji button"
    },
    changeEmojiShortnameButtonLabel: {
        id: "fabric.emoji.change.shortname.button.label",
        defaultMessage: "Change emoji, currently {shortName}"
    },
    error: {
        id: "fabric.emoji.emojipicker.error",
        defaultMessage: "Error!"
    }
});
module.exports["messages"] = $359e221f768e8d0f$export$defe85febe8b728c;

});

parcelRegister("eu2js", function(module, exports) {
$parcel$export(module.exports, "default", () => $041318c0fd90062e$export$2e2bcd8739ae039);
function $041318c0fd90062e$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("aGYoD", function(module, exports) {
var $8ed425f4cd04a9ee$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $8ed425f4cd04a9ee$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $8ed425f4cd04a9ee$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $8ed425f4cd04a9ee$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $8ed425f4cd04a9ee$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $8ed425f4cd04a9ee$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $8ed425f4cd04a9ee$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});
module.exports["SearchSort"] = $8ed425f4cd04a9ee$export$a15e9a4340d08b2e;
module.exports["SearchSourceTypes"] = $8ed425f4cd04a9ee$export$db41220f541db607;
module.exports["ProviderTypes"] = $8ed425f4cd04a9ee$export$bf337c9223e5c8b;
module.exports["UfoExperienceName"] = $8ed425f4cd04a9ee$export$d0d1c9cd31a11a64;
module.exports["UfoComponentName"] = $8ed425f4cd04a9ee$export$122ce5c8fda96269;
module.exports["UfoEmojiTimingsKeys"] = $8ed425f4cd04a9ee$export$265ee18146a6885e;
module.exports["UfoEmojiTimings"] = $8ed425f4cd04a9ee$export$482549d945a3723;

});

parcelRegister("dS4Ej", function(module, exports) {

var $jDv0c = parcelRequire("jDv0c");

class $48b627853b066693$export$2e2bcd8739ae039 {
    /**
   * Returns a promise with an array of Emoji from all providers.
   */ loadEmoji() {
        const emojisPromise = (0, $jDv0c.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $jDv0c.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
    constructor(config){
        this.config = void 0;
        this.config = config;
    }
}
module.exports["default"] = $48b627853b066693$export$2e2bcd8739ae039;

});

parcelRegister("jDv0c", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $aGYoD = parcelRequire("aGYoD");


var $40rXS = parcelRequire("40rXS");


var $fB3RY = parcelRequire("fB3RY");


var $fJJ4V = parcelRequire("fJJ4V");

const $e511e678d699abc5$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $e511e678d699abc5$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $e511e678d699abc5$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $dwp40.utils).requestService(serviceConfig, requestOptions);
};
const $e511e678d699abc5$var$calculateScale = (getRatio)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_emoji_default_scale', 'isEnabled', true)) {
        // retina display
        if (getRatio() > 1) return {
            scale: 'XXXHDPI',
            altScale: 'XXXHDPI'
        };
        // default set used for desktop
        return {
            altScale: 'XXXHDPI'
        };
    }
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $e511e678d699abc5$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $e511e678d699abc5$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$e511e678d699abc5$var$calculateScale($e511e678d699abc5$export$d39ce20a37bba061).altScale];
};
const $e511e678d699abc5$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $e511e678d699abc5$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $40rXS.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $40rXS.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($e511e678d699abc5$export$db05e6ae1fd416af(imagePath, meta)) return (0, $40rXS.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $fB3RY.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $e511e678d699abc5$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $e511e678d699abc5$export$55077db3efc820aa($e511e678d699abc5$export$4a0301d636367e1d(altReps), meta);
};
const $e511e678d699abc5$var$denormaliseStandardRepresentation = (emoji, meta)=>{
    const unicodeEmoji = (0, $fJJ4V.emojiIdToEmoji)(emoji.id);
    const useUnicodeRepresentation = !!(emoji.id && emoji.type === (0, $aGYoD.ProviderTypes).STANDARD && unicodeEmoji && (0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true));
    return useUnicodeRepresentation ? {
        unicodeEmoji: unicodeEmoji
    } : $e511e678d699abc5$export$55077db3efc820aa(emoji.representation, meta);
};
const $e511e678d699abc5$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: _representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $e511e678d699abc5$var$denormaliseStandardRepresentation(skin, meta),
            altRepresentation: $e511e678d699abc5$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $e511e678d699abc5$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $e511e678d699abc5$var$denormaliseStandardRepresentation(emoji, emojiData.meta);
        const altRepresentation = $e511e678d699abc5$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $e511e678d699abc5$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: _representation, skinVariations: _skinVariations, altRepresentations: _altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $40rXS.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $e511e678d699abc5$var$getHeight = (fitToHeight)=>$e511e678d699abc5$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $e511e678d699abc5$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $e511e678d699abc5$var$getHeight(fitToHeight) > emoji.representation.height);
module.exports["emojiRequest"] = $e511e678d699abc5$export$ea1accde4cc117f4;
module.exports["getAltRepresentation"] = $e511e678d699abc5$export$4a0301d636367e1d;
module.exports["denormaliseEmojiServiceResponse"] = $e511e678d699abc5$export$afaea97e40b5ca70;
module.exports["shouldUseAltRepresentation"] = $e511e678d699abc5$export$b7e9058f156d8d19;

});

parcelRegister("dZ8uq", function(module, exports) {

var $8Qxmq = parcelRequire("8Qxmq");

function $9f9b36b6d620d73c$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $8Qxmq.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}
module.exports["expValEqualsNoExposure"] = $9f9b36b6d620d73c$export$63eebf86443a0a61;

});

parcelRegister("fJJ4V", function(module, exports) {

var $dZ8uq = parcelRequire("dZ8uq");

const $5c78426e86184695$var$KEYCAP_COMBINING = 0x20e3;
const $5c78426e86184695$var$VARIATION_SELECTOR_16 = 0xfe0f;
const $5c78426e86184695$var$VARIATION_SELECTOR_15 = 0xfe0e;
const $5c78426e86184695$var$EMOJI_MODIFIER_START = 0x1f3fb;
const $5c78426e86184695$var$EMOJI_MODIFIER_END = 0x1f3ff;
const $5c78426e86184695$var$REGIONAL_INDICATOR_START = 0x1f1e6;
const $5c78426e86184695$var$REGIONAL_INDICATOR_END = 0x1f1ff;
const $5c78426e86184695$var$FLAG_BASES = new Set([
    0x1f38c,
    0x1f3c1,
    0x1f3f3,
    0x1f3f4,
    0x1f6a9
]);
// Emoji variation bases from Unicode 14.0 emoji-variation-sequences.txt.
// These are the code points with a defined U+FE0F emoji-style variant.
const $5c78426e86184695$var$EMOJI_VARIATION_BASES = new Set([
    0x0023,
    0x002a,
    0x0030,
    0x0031,
    0x0032,
    0x0033,
    0x0034,
    0x0035,
    0x0036,
    0x0037,
    0x0038,
    0x0039,
    0x00a9,
    0x00ae,
    0x203c,
    0x2049,
    0x2122,
    0x2139,
    0x2194,
    0x2195,
    0x2196,
    0x2197,
    0x2198,
    0x2199,
    0x21a9,
    0x21aa,
    0x2328,
    0x23cf,
    0x23ed,
    0x23ee,
    0x23ef,
    0x23f1,
    0x23f2,
    0x23f8,
    0x23f9,
    0x23fa,
    0x24c2,
    0x25aa,
    0x25ab,
    0x25b6,
    0x25c0,
    0x25fb,
    0x25fc,
    0x2600,
    0x2601,
    0x2602,
    0x2603,
    0x2604,
    0x260e,
    0x2611,
    0x2618,
    0x261d,
    0x2620,
    0x2622,
    0x2623,
    0x2626,
    0x262a,
    0x262e,
    0x262f,
    0x2638,
    0x2639,
    0x263a,
    0x2640,
    0x2642,
    0x265f,
    0x2660,
    0x2663,
    0x2665,
    0x2666,
    0x2668,
    0x267b,
    0x267e,
    0x2692,
    0x2694,
    0x2695,
    0x2696,
    0x2697,
    0x2699,
    0x269b,
    0x269c,
    0x26a0,
    0x26a7,
    0x26b0,
    0x26b1,
    0x26c8,
    0x26cf,
    0x26d1,
    0x26d3,
    0x26e9,
    0x26f0,
    0x26f1,
    0x26f4,
    0x26f7,
    0x26f8,
    0x26f9,
    0x2702,
    0x2708,
    0x2709,
    0x270c,
    0x270d,
    0x270f,
    0x2712,
    0x2714,
    0x2716,
    0x271d,
    0x2721,
    0x2733,
    0x2734,
    0x2744,
    0x2747,
    0x2763,
    0x2764,
    0x27a1,
    0x2934,
    0x2935,
    0x2b05,
    0x2b06,
    0x2b07,
    0x3030,
    0x303d,
    0x3297,
    0x3299,
    0x1f170,
    0x1f171,
    0x1f17e,
    0x1f17f,
    0x1f202,
    0x1f237,
    0x1f321,
    0x1f324,
    0x1f325,
    0x1f326,
    0x1f327,
    0x1f328,
    0x1f329,
    0x1f32a,
    0x1f32b,
    0x1f32c,
    0x1f336,
    0x1f37d,
    0x1f396,
    0x1f397,
    0x1f399,
    0x1f39a,
    0x1f39b,
    0x1f39e,
    0x1f39f,
    0x1f3cb,
    0x1f3cc,
    0x1f3cd,
    0x1f3ce,
    0x1f3d4,
    0x1f3d5,
    0x1f3d6,
    0x1f3d7,
    0x1f3d8,
    0x1f3d9,
    0x1f3da,
    0x1f3db,
    0x1f3dc,
    0x1f3dd,
    0x1f3de,
    0x1f3df,
    0x1f3f3,
    0x1f3f5,
    0x1f3f7,
    0x1f43f,
    0x1f441,
    0x1f4fd,
    0x1f549,
    0x1f54a,
    0x1f56f,
    0x1f570,
    0x1f573,
    0x1f574,
    0x1f575,
    0x1f576,
    0x1f577,
    0x1f578,
    0x1f579,
    0x1f587,
    0x1f58a,
    0x1f58b,
    0x1f58c,
    0x1f58d,
    0x1f590,
    0x1f5a5,
    0x1f5a8,
    0x1f5b1,
    0x1f5b2,
    0x1f5bc,
    0x1f5c2,
    0x1f5c3,
    0x1f5c4,
    0x1f5d1,
    0x1f5d2,
    0x1f5d3,
    0x1f5dc,
    0x1f5dd,
    0x1f5de,
    0x1f5e1,
    0x1f5e3,
    0x1f5e8,
    0x1f5ef,
    0x1f5f3,
    0x1f5fa,
    0x1f6cb,
    0x1f6cd,
    0x1f6ce,
    0x1f6cf,
    0x1f6e0,
    0x1f6e1,
    0x1f6e2,
    0x1f6e3,
    0x1f6e4,
    0x1f6e5,
    0x1f6e9,
    0x1f6f0,
    0x1f6f3,
    0x231a,
    0x231b,
    0x23e9,
    0x23ea,
    0x23f3,
    0x25fd,
    0x25fe,
    0x2614,
    0x2615,
    0x2648,
    0x2649,
    0x264a,
    0x264b,
    0x264c,
    0x264d,
    0x264e,
    0x264f,
    0x2650,
    0x2651,
    0x2652,
    0x2653,
    0x267f,
    0x2693,
    0x26a1,
    0x26aa,
    0x26ab,
    0x26bd,
    0x26be,
    0x26c4,
    0x26c5,
    0x26d4,
    0x26ea,
    0x26f2,
    0x26f3,
    0x26f5,
    0x26fa,
    0x26fd,
    0x2753,
    0x2757,
    0x2b1b,
    0x2b1c,
    0x2b50,
    0x2b55,
    0x1f004,
    0x1f21a,
    0x1f22f,
    0x1f30d,
    0x1f30e,
    0x1f30f,
    0x1f315,
    0x1f31c,
    0x1f378,
    0x1f393,
    0x1f3a7,
    0x1f3ac,
    0x1f3ad,
    0x1f3ae,
    0x1f3c2,
    0x1f3c4,
    0x1f3c6,
    0x1f3ca,
    0x1f3e0,
    0x1f3ed,
    0x1f408,
    0x1f415,
    0x1f41f,
    0x1f426,
    0x1f442,
    0x1f446,
    0x1f447,
    0x1f448,
    0x1f449,
    0x1f44d,
    0x1f44e,
    0x1f453,
    0x1f46a,
    0x1f47d,
    0x1f4a3,
    0x1f4b0,
    0x1f4b3,
    0x1f4bb,
    0x1f4bf,
    0x1f4cb,
    0x1f4da,
    0x1f4df,
    0x1f4e4,
    0x1f4e5,
    0x1f4e6,
    0x1f4ea,
    0x1f4eb,
    0x1f4ec,
    0x1f4ed,
    0x1f4f7,
    0x1f4f9,
    0x1f4fa,
    0x1f4fb,
    0x1f508,
    0x1f50d,
    0x1f512,
    0x1f513,
    0x1f550,
    0x1f551,
    0x1f552,
    0x1f553,
    0x1f554,
    0x1f555,
    0x1f556,
    0x1f557,
    0x1f558,
    0x1f559,
    0x1f55a,
    0x1f55b,
    0x1f55c,
    0x1f55d,
    0x1f55e,
    0x1f55f,
    0x1f560,
    0x1f561,
    0x1f562,
    0x1f563,
    0x1f564,
    0x1f565,
    0x1f566,
    0x1f567,
    0x1f610,
    0x1f687,
    0x1f68d,
    0x1f691,
    0x1f694,
    0x1f698,
    0x1f6ad,
    0x1f6b2,
    0x1f6b9,
    0x1f6ba,
    0x1f6bc
]);
const $5c78426e86184695$var$isEmojiModifier = (codePoint)=>typeof codePoint === 'number' && codePoint >= $5c78426e86184695$var$EMOJI_MODIFIER_START && codePoint <= $5c78426e86184695$var$EMOJI_MODIFIER_END;
const $5c78426e86184695$var$shouldAddEmojiPresentationSelector = (codePoint, nextCodePoint)=>$5c78426e86184695$var$EMOJI_VARIATION_BASES.has(codePoint) && nextCodePoint !== $5c78426e86184695$var$VARIATION_SELECTOR_16 && nextCodePoint !== $5c78426e86184695$var$VARIATION_SELECTOR_15 && nextCodePoint !== $5c78426e86184695$var$KEYCAP_COMBINING && !$5c78426e86184695$var$isEmojiModifier(nextCodePoint);
const $5c78426e86184695$var$isRegionalIndicator = (codePoint)=>codePoint >= $5c78426e86184695$var$REGIONAL_INDICATOR_START && codePoint <= $5c78426e86184695$var$REGIONAL_INDICATOR_END;
const $5c78426e86184695$var$parseEmojiIdCodePoints = (id)=>{
    const segments = id.split('-');
    const codePoints = [];
    for (const segment of segments){
        if (!/^[0-9a-fA-F]+$/.test(segment)) return undefined;
        const cp = parseInt(segment, 16);
        // Valid Unicode scalar values: U+0000–U+10FFFF, excluding surrogates.
        if (isNaN(cp) || cp < 0 || cp > 0x10ffff || cp >= 0xd800 && cp <= 0xdfff) return undefined;
        codePoints.push(cp);
    }
    return codePoints.length ? codePoints : undefined;
};
const $5c78426e86184695$var$isFlagEmoji = (codePoints)=>{
    if (codePoints.length === 2 && codePoints.every($5c78426e86184695$var$isRegionalIndicator)) return true;
    return $5c78426e86184695$var$FLAG_BASES.has(codePoints[0]);
};
function $5c78426e86184695$export$ad632d8144af7c7b(id) {
    if (!(0, $dZ8uq.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) return undefined;
    if (!id) return undefined;
    const codePoints = $5c78426e86184695$var$parseEmojiIdCodePoints(id);
    if (!codePoints) return undefined;
    if ($5c78426e86184695$var$isFlagEmoji(codePoints)) return undefined;
    const processedCodePoints = [];
    for(let i = 0; i < codePoints.length; i++){
        const cp = codePoints[i];
        const next = codePoints[i + 1];
        processedCodePoints.push(cp);
        // Insert U+FE0F before U+20E3 if not already present.
        // Keycap sequences: digit/# /* followed by U+20E3 need U+FE0F between them.
        if (next === $5c78426e86184695$var$KEYCAP_COMBINING && cp !== $5c78426e86184695$var$VARIATION_SELECTOR_16) processedCodePoints.push($5c78426e86184695$var$VARIATION_SELECTOR_16);
        // Emoji variation bases need U+FE0F immediately after the base code point,
        // including when the base appears inside a ZWJ sequence.
        if ($5c78426e86184695$var$shouldAddEmojiPresentationSelector(cp, next)) processedCodePoints.push($5c78426e86184695$var$VARIATION_SELECTOR_16);
    }
    try {
        return String.fromCodePoint(...processedCodePoints);
    } catch  {
        return undefined;
    }
}
module.exports["emojiIdToEmoji"] = $5c78426e86184695$export$ad632d8144af7c7b;

});

parcelRegister("cnv66", function(module, exports) {
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $5cf1289fec364e56$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $5cf1289fec364e56$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $5cf1289fec364e56$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $5cf1289fec364e56$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $5cf1289fec364e56$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $5cf1289fec364e56$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $5cf1289fec364e56$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    };
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $5cf1289fec364e56$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $5cf1289fec364e56$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    };
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $5cf1289fec364e56$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $5cf1289fec364e56$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($5cf1289fec364e56$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $5cf1289fec364e56$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $5cf1289fec364e56$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$5cf1289fec364e56$export$eeaf491a400e882a.constructor = false;
$5cf1289fec364e56$export$eeaf491a400e882a.hasOwnProperty = false;
$5cf1289fec364e56$export$eeaf491a400e882a.isPrototypeOf = false;
$5cf1289fec364e56$export$eeaf491a400e882a.propertyIsEnumerable = false;
$5cf1289fec364e56$export$eeaf491a400e882a.toLocaleString = false;
$5cf1289fec364e56$export$eeaf491a400e882a.toString = false;
$5cf1289fec364e56$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $5cf1289fec364e56$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$5cf1289fec364e56$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $5cf1289fec364e56$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5cf1289fec364e56$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5cf1289fec364e56$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5cf1289fec364e56$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $5cf1289fec364e56$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $5cf1289fec364e56$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $5cf1289fec364e56$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $5cf1289fec364e56$export$147e8ac43c84713a();
        this._tokenizer = new $5cf1289fec364e56$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    };
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    };
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    };
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    };
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $5cf1289fec364e56$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $5cf1289fec364e56$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $5cf1289fec364e56$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $5cf1289fec364e56$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $5cf1289fec364e56$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $5cf1289fec364e56$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    };
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();



var $fhsiz = parcelRequire("fhsiz");


var $40rXS = parcelRequire("40rXS");


var $aGYoD = parcelRequire("aGYoD");

// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $d516564d39c540e3$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');








var $dbf21a8f9389acb4$var$_OrderComparator, $dbf21a8f9389acb4$var$_AlphabeticalShortnameComparator;
function $dbf21a8f9389acb4$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $dbf21a8f9389acb4$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $dbf21a8f9389acb4$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $dbf21a8f9389acb4$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $dbf21a8f9389acb4$export$587c775915dc4869(textQuery, 'shortName'), new $dbf21a8f9389acb4$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($dbf21a8f9389acb4$export$165e96ceead77edd.Instance, $dbf21a8f9389acb4$export$30ce221e1adf48c1.Instance);
    const comparator = new $dbf21a8f9389acb4$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $dbf21a8f9389acb4$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $dbf21a8f9389acb4$export$a8052d0852821684(new $dbf21a8f9389acb4$export$55e24837a4bf653(orderedIds), new $dbf21a8f9389acb4$export$a7f7a0b04013a8a8(), $dbf21a8f9389acb4$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $dbf21a8f9389acb4$export$a8052d0852821684 {
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
    constructor(...comparators){
        this.chain = void 0;
        this.chain = comparators;
    }
}
class $dbf21a8f9389acb4$export$ff92575cd1bbad0e {
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
    constructor(query){
        this.query = void 0;
        this.query = query;
    }
}
class $dbf21a8f9389acb4$export$3026b08b79541139 {
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
    constructor(query){
        this.colonQuery = void 0;
        this.typeComparator = void 0;
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $dbf21a8f9389acb4$export$a7f7a0b04013a8a8(true);
    }
}
class $dbf21a8f9389acb4$export$a7f7a0b04013a8a8 {
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
    constructor(reverse){
        this.typeToNumber = void 0;
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
}
class $dbf21a8f9389acb4$export$55e24837a4bf653 {
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
   * Get the ordinal representing the position of this emoji.
   *
   * @param id the id of the emoji
   */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $40rXS.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $fhsiz.MAX_ORDINAL;
    }
    constructor(orderedIds){
        // A Map of emoji base Id to their order in a least of most frequently used
        this.positionLookup = void 0;
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
}
class $dbf21a8f9389acb4$export$587c775915dc4869 {
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $fhsiz.MAX_ORDINAL);
        return score === -1 ? (0, $fhsiz.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
    /**
   * @param query the query to match
   * @param propertyToCompare the property of EmojiDescription to check for query within
   */ constructor(query, propertyToCompare){
        this.propertyName = void 0;
        this.query = void 0;
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
}
class $dbf21a8f9389acb4$export$165e96ceead77edd {
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $fhsiz.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $fhsiz.MAX_ORDINAL);
        return o1 - o2;
    }
    constructor(){}
}
$dbf21a8f9389acb4$var$_OrderComparator = $dbf21a8f9389acb4$export$165e96ceead77edd;
$dbf21a8f9389acb4$export$165e96ceead77edd.INSTANCE = void 0;
class $dbf21a8f9389acb4$export$30ce221e1adf48c1 {
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
    constructor(){}
}
$dbf21a8f9389acb4$var$_AlphabeticalShortnameComparator = $dbf21a8f9389acb4$export$30ce221e1adf48c1;
$dbf21a8f9389acb4$export$30ce221e1adf48c1.INSTANCE = void 0;



var $aUjB3 = parcelRequire("aUjB3");


var $dh538 = parcelRequire("dh538");


var $c6GJD = parcelRequire("c6GJD");

// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $d131d8801f1bddda$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $d516564d39c540e3$export$6558e5d0f0e834f8).lastIndex = 0;
        while((match = (0, $d516564d39c540e3$export$6558e5d0f0e834f8).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $d131d8801f1bddda$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $40rXS.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$d131d8801f1bddda$var$addAllVariants(variation, fnKey, map));
    }
};
const $d131d8801f1bddda$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $d131d8801f1bddda$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $d131d8801f1bddda$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $40rXS.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $d131d8801f1bddda$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
const $d131d8801f1bddda$var$teamojiRefreshExperimentName = 'platform_teamoji_26_refresh_emoji_picker';
const $d131d8801f1bddda$var$isRefreshEmojiPickerEnabled = ()=>{
    if (!(0, $c6GJD.default).initializeCompleted()) return false;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const isEnabled = (0, $c6GJD.default).getExperimentValue($d131d8801f1bddda$var$teamojiRefreshExperimentName, 'isEnabled', false);
    return isEnabled;
};
class $d131d8801f1bddda$export$2e2bcd8739ae039 {
    /**
   * Returns all available (and searchable) emoji in some default order.
   */ all() {
        const options = {
            sort: (0, $aGYoD.SearchSort).None
        };
        return this.search('', options);
    }
    /**
   * Text search of emoji shortName and name field for suitable matches.
   *
   * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
   *
   * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
   * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
   * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
   */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $d131d8801f1bddda$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
   * Returns all emoji with matching shortName
   */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
   * Returns the first matching emoji matching the shortName, or null if none found.
   */ findByShortName(shortName) {
        return $d131d8801f1bddda$var$findByKey(this.shortNameMap, shortName);
    }
    /**
   * Returns the first matching emoji matching the id, or null if none found.
   */ findById(id) {
        return $d131d8801f1bddda$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $fhsiz.frequentCategory)) return this.getFrequentlyUsed();
        else if (categoryId === 'ATLASSIAN') return this.all().emojis.filter((emoji)=>emoji.category === categoryId || emoji.type === 'ATLASSIAN');
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
   * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
   * there are none.
   *
   * @param options optional settings to be applied to the set of frequently used emoji
   */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
   * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
   * in sorting, etc).
   *
   * @param emoji the emoji that was just used
   */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $fhsiz.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $fhsiz.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $d131d8801f1bddda$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $aGYoD.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $aGYoD.SearchSort).Default) comparator = (0, $dbf21a8f9389acb4$export$e6097b005751df7)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $aGYoD.SearchSort).UsageFrequency) comparator = (0, $dbf21a8f9389acb4$export$1bd055808eeccb4e)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $d131d8801f1bddda$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $aUjB3.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $dh538.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
   * Optimisation to initialise all map member variables in single loop over emojis
   */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(this.getDynamicCategoryForEmoji(emoji));
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $fhsiz.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $fhsiz.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $5cf1289fec364e56$export$4b85d3515bd863a5)('id');
        this.fullSearch.tokenizer = new $d131d8801f1bddda$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $5cf1289fec364e56$export$5e70dbef3f0d47db)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        if ($d131d8801f1bddda$var$isRefreshEmojiPickerEnabled()) this.fullSearch.addIndex('keywords');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $d131d8801f1bddda$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $d131d8801f1bddda$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $d131d8801f1bddda$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $d131d8801f1bddda$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = this.getDynamicCategoryForEmoji(emoji);
        if ((0, $fhsiz.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
    getDynamicCategoryForEmoji(emoji) {
        const category = (0, $40rXS.getCategoryId)(emoji);
        if (emoji.type === 'ATLASSIAN' && category !== (0, $fhsiz.frequentCategory)) return 'ATLASSIAN';
        return category;
    }
    constructor(emojis, usageTracker){
        this.emojis = void 0;
        this.fullSearch = void 0;
        this.fullSearchReady = false;
        this.shortNameMap = void 0;
        this.idMap = void 0;
        this.asciiMap = void 0;
        this.dynamicCategoryList = void 0;
        // protected to allow subclasses to access (for testing and storybooks).
        this.usageTracker = void 0;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
}
$d131d8801f1bddda$export$2e2bcd8739ae039.defaultEmojiWeight = 1000000;
module.exports["getEmojiVariation"] = $d131d8801f1bddda$export$e55e46e1520c899d;
module.exports["default"] = $d131d8801f1bddda$export$2e2bcd8739ae039;

});

parcelRegister("aUjB3", function(module, exports) {

var $40rXS = parcelRequire("40rXS");


var $fhsiz = parcelRequire("fhsiz");

/**
 * The options used to configure a newly constructed queue.
 */ class $529528ebb82def7c$export$2e2bcd8739ae039 {
    /**
   * @param item the item to add to the queue.
   */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items in the queue, ordered by how often they are duplicated. The items with the
   * most duplicates come first in the returned Array.
   *
   * If there are no items in the queue then an empty Array will be returned.
   */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue.
   */ clear() {
        this.createEmptyState();
    }
    /**
   * A more efficient mechanism for adding multiple items. Ordering is only performed once all
   * the items have been added.
   *
   * @param items the items to be enqueued, which happens in their presented order.
   */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items currently stored in the queue.
   */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
   * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
   * performed by this enqueuing. You must trigger that manually if required.
   *
   * @param item the item to be queued
   */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
   * Get an array of items from the queue ordered by how often they are duplicated in the queue.
   */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
   * Walk the list of items and remove the first occurrence of the matching item.
   *
   * @param item the item to be removed.
   */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
   * Remove the first item from the queue and update the itemCountMap accordingly.
   * @return the item add the front of the queue or undefined if the queue is empty
   */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
   * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
   * @param item the item to be added to the queue
   */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
    /**
   * Construct a new DuplicateLimitedQueue.
   *
   * @param options the options for this queue.
   */ constructor(options){
        this.maximumSize = void 0;
        this.perItemSize = void 0;
        this.items = void 0;
        this.itemCountMap = void 0;
        /**
     * An array derived from items and itemCountMap which holds each item once and is ordered by
     * how often an item is duplicated in the items array.
     */ this.itemsOrderedByFrequency = void 0;
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
}




var $fB3RY = parcelRequire("fB3RY");

class $6fcf5ab5d0cd0dd9$export$2e2bcd8739ae039 extends (0, $529528ebb82def7c$export$2e2bcd8739ae039) {
    /**
   * Enqueue the supplied item and also persist the new contents of the queue to storage.
   *
   * @param item the item to be enqueued
   */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
   */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
   * Initialise the queue contents from the configured Storage. If there is no data found in
   * storage then the queue will have no items added. Likewise, a failure to read or parse stored
   * data will be swallowed and no items are added to the queue.
   */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $fB3RY.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
   * Save the current items in the queue, overwriting any previously stored queue.
   * Any failure in saving will be silently ignored with the likely outcome that any previous
   * saved items will remain unchanged in storage.
   */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $fB3RY.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
    constructor(options){
        super(options);
        this.storage = void 0;
        this.prefixedStorageKey = void 0;
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$6fcf5ab5d0cd0dd9$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
}
$6fcf5ab5d0cd0dd9$export$2e2bcd8739ae039.storageKey = 'lastUsed';



var $eu2js = parcelRequire("eu2js");

class $d662efc6fcc59d49$export$3f86810331c44209 {
    /**
   * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
   * count on getOrder() reflecting this usage immediately.
   *
   * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
   */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $40rXS.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
   * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
   * are no usages then an empty array will be returned.
   */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
   * Exposed for testing only. Clear any recorded usage.
   */ clear() {
        this.queue.clear();
    }
    constructor(useStorageIfPossible = true){
        this.queue = void 0;
        this.gateway = void 0;
        const options = $d662efc6fcc59d49$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $6fcf5ab5d0cd0dd9$export$2e2bcd8739ae039)(queueOptions);
        } else this.queue = new (0, $529528ebb82def7c$export$2e2bcd8739ae039)(options);
        this.gateway = new $d662efc6fcc59d49$export$a0e1fa6601cae894(10);
    }
}
$d662efc6fcc59d49$export$3f86810331c44209.queueOptions = {
    storage: (0, $eu2js.default)('localStorage') ? window.localStorage : undefined,
    storagePrefix: (0, $fhsiz.localStoragePrefix),
    maxDuplicates: 25,
    minUniqueItems: 5
};
class $d662efc6fcc59d49$export$a0e1fa6601cae894 {
    /**
   * Run the supplied function if the count of already submitted work allows it. Drop the work
   * if it's not allowed to run.
   *
   * Will return true if the function has been submitted or false if it was not submitted.
   */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
    constructor(maximumPermitted){
        this.maximumPermitted = void 0;
        this.count = void 0;
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
}
module.exports["UsageFrequencyTracker"] = $d662efc6fcc59d49$export$3f86810331c44209;

});

parcelRegister("grxv4", function(module, exports) {

var $9CkUQ = parcelRequire("9CkUQ");

const $f10760e0a087c3f8$export$f92e83e86b03c398 = new Map();
const $f10760e0a087c3f8$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $9CkUQ.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $f10760e0a087c3f8$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $9CkUQ.MediaClient)(mediaClientConfig);
        $f10760e0a087c3f8$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
module.exports["getMediaClient"] = $f10760e0a087c3f8$export$c9ecbc1b719fd417;

});

parcelRegister("9CkUQ", function(module, exports) {

var $majy4 = parcelRequire("majy4");

parcelRequire("5vzpD");
var $9zykx = parcelRequire("9zykx");


var $dPp8R = parcelRequire("dPp8R");


var $fO7zn = parcelRequire("fO7zn");

class $663f907f59c08826$export$c66ca190f89caaac {
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
    constructor(baseUrl){
        this.baseUrl = void 0;
        this.baseUrl = baseUrl || '/gateway/api';
    }
}


parcelRequire("9EPd0");
var $eUfuX = parcelRequire("eUfuX");


class $125343a0ad3859dc$export$fba8b4ca6d386aec {
    /**
   * @internal
   */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getClientId(collectionName) {
        return this.mediaStore.getClientId(collectionName);
    }
    getClientIdSync() {
        return this.mediaStore.getClientIdSync();
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("1kgKO"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
    constructor(mediaClientConfig, store = (0, $eUfuX.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = void 0;
        this.file = void 0;
        this.stargate = void 0;
        this.eventEmitter = void 0;
        // mobile upload is lazily loaded
        this.mobileUpload = void 0;
        // Deprecated value introduced for backward compatibility with Context
        this.config = void 0;
        this.mediaStore = mediaApi ?? new (0, $dPp8R.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $9zykx.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $fO7zn.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $majy4.EventEmitter2)();
        this.stargate = new (0, $663f907f59c08826$export$c66ca190f89caaac)(mediaClientConfig.stargateBaseUrl);
    }
}
module.exports["MediaClient"] = $125343a0ad3859dc$export$fba8b4ca6d386aec;

});

parcelRegister("majy4", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $kyRHQ = parcelRequire("kyRHQ");

!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $kyRHQ !== 'undefined' && $kyRHQ.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $kyRHQ.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("5vzpD", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("dAAeA")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("3HtSd")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("3HtSd")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("9zykx")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $dAAeA = parcelRequire("dAAeA");


var $3HtSd = parcelRequire("3HtSd");


var $9zykx = parcelRequire("9zykx");


});

parcelRegister("3HtSd", function(module, exports) {
function $fc43f434b1cd1f5a$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $fc43f434b1cd1f5a$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $fc43f434b1cd1f5a$export$17f6055767a8d96a = (auth)=>{
    if ($fc43f434b1cd1f5a$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};
module.exports["isClientBasedAuth"] = $fc43f434b1cd1f5a$export$6ba49fcac9c46e54;
module.exports["authToOwner"] = $fc43f434b1cd1f5a$export$17f6055767a8d96a;

});

parcelRegister("dPp8R", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

parcelRequire("5vzpD");
var $9zykx = parcelRequire("9zykx");
var $3HtSd = parcelRequire("3HtSd");


var $3x2Xc = parcelRequire("3x2Xc");


var $cMT0u = parcelRequire("cMT0u");


var $2ASLw = parcelRequire("2ASLw");

var $6Nh2I = parcelRequire("6Nh2I");


var $4lI5c = parcelRequire("4lI5c");


var $4HHlm = parcelRequire("4HHlm");


var $dh538 = parcelRequire("dh538");


var $dIgeg = parcelRequire("dIgeg");

class $9cdaa8fc0b93ea2b$export$b78480bd311630bc extends (0, $dIgeg.BaseMediaClientError) {
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
}
function $9cdaa8fc0b93ea2b$export$8d2a9b675b2ce37a(err) {
    return err instanceof $9cdaa8fc0b93ea2b$export$b78480bd311630bc;
}


const $e96d427b6e70a0fc$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e96d427b6e70a0fc$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });



var $eGqQQ = parcelRequire("eGqQQ");

const $12f3d9e88ec42754$export$560085fe411c0660 = 10000;
const $12f3d9e88ec42754$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $12f3d9e88ec42754$export$560085fe411c0660)=>{
    const startTime = performance.now();
    let eventEmitted = false;
    // Feature flag: wrap authProvider with analytics event emission
    const authProviderPromise = (0, $dh538.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then((result)=>{
        const durationMs = performance.now() - startTime;
        if (!eventEmitted) {
            eventEmitted = true;
            (0, $eGqQQ.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext
            });
        } else {
            // Timeout already fired - auth arrived too late
            const timeoutError = new (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)('authProviderTimedOut');
            (0, $eGqQQ.globalMediaEventEmitter).emit('auth-provider-failed', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext,
                error: timeoutError
            });
        }
        return result;
    }).catch((error)=>{
        const durationMs = performance.now() - startTime;
        eventEmitted = true;
        (0, $eGqQQ.globalMediaEventEmitter).emit('auth-provider-failed', {
            durationMs: durationMs,
            timeoutMs: authProviderTimeout,
            authContext: authContext,
            error: error
        });
        throw error;
    }) : authProvider(authContext); // Original behavior when FG off
    let auth;
    try {
        auth = await Promise.race([
            authProviderPromise,
            (0, $e96d427b6e70a0fc$export$cf2d2a1124beacb2)(authProviderTimeout, new (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)('authProviderTimedOut'))
        ]);
    } catch (err) {
        // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
        if (!eventEmitted && (0, $dh538.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
        // PRESERVE ORIGINAL ERROR HANDLING
        if (err instanceof (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)) throw err;
        throw new (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)('emptyAuth');
    /*
	Only client-based auth carries a clientId. Fail fast when it is present but empty, instead of
	letting the request reach dt-auth and get rejected with `Client id "" is invalid`.
  */ if ('clientId' in auth && !auth.clientId && (0, $dh538.fg)('platform_media_validate_client_id')) throw new (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)('emptyClientId');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $12f3d9e88ec42754$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $9cdaa8fc0b93ea2b$export$b78480bd311630bc)('missingInitialAuth');
    return auth;
};



var $deNRp = parcelRequire("deNRp");

function $46e8da9f0d2d6a2a$export$5296269cf74e58e(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return undefined;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        const watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch  {
        return undefined;
    }
}





const $55c1ab2cd2f0d946$var$MEDIA_API_REGION = 'media-api-region';
const $55c1ab2cd2f0d946$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $55c1ab2cd2f0d946$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $3x2Xc.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $3x2Xc.MAX_RESOLUTION),
            height: (0, $3x2Xc.MAX_RESOLUTION)
        } : {}
    };
};
const $55c1ab2cd2f0d946$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $55c1ab2cd2f0d946$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $4HHlm.isCDNEnabled)()) result += '/cdn';
    return result;
};
const $55c1ab2cd2f0d946$var$decodeJwtToken = (token)=>{
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};
class $55c1ab2cd2f0d946$export$572b8a2a9fd7cbba {
    async getClientId(collectionName) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return $55c1ab2cd2f0d946$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
    }
    getClientIdSync() {
        try {
            const auth = this.resolveInitialAuth();
            return $55c1ab2cd2f0d946$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
        } catch  {
            // initialAuth may not be available, return undefined
            return undefined;
        }
    }
    static extractClientIdFromAuth(auth) {
        if ((0, $3HtSd.isClientBasedAuth)(auth)) return auth.clientId;
        // decode JWT token and get clientId (or iss) from payload
        try {
            const jwtPayload = $55c1ab2cd2f0d946$var$decodeJwtToken(auth.token);
            return jwtPayload.clientId;
        } catch  {
        // leave clientId as undefined
        }
        return undefined;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const headers = {
            ...$55c1ab2cd2f0d946$var$jsonHeaders
        };
        if (options?.expectedFileSize !== undefined && (0, $dh538.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', requestOptions).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const headers = {
            ...$55c1ab2cd2f0d946$var$jsonHeaders
        };
        if (options?.expectedFileSize !== undefined && (0, $dh538.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', requestOptions).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const wmv = (0, $dh538.fg)('confluence_watermark_admin_ui') ? (0, $46e8da9f0d2d6a2a$export$5296269cf74e58e)(auth.token) : undefined;
        const options = {
            params: {
                ...$55c1ab2cd2f0d946$var$extendImageParams(params),
                ...wmv ? {
                    wmv: wmv
                } : {}
            },
            auth: auth
        };
        const imageEndpoint = $55c1ab2cd2f0d946$var$cdnFeatureFlag('image');
        if ((0, $deNRp.isPathBasedEnabled)()) return (0, $deNRp.mapToPathBasedUrl)((0, $4lI5c.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $4HHlm.mapToMediaCdnUrl)((0, $4lI5c.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $3x2Xc.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $55c1ab2cd2f0d946$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $4lI5c.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $3x2Xc.FILE_CACHE_MAX_AGE), name) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge,
                ...name && (0, $1oCLl.expValEquals)('platform_editor_media_download_fallback_name', 'isEnabled', true) ? {
                    name: name
                } : {}
            },
            auth: auth
        };
        const binaryEndpoint = $55c1ab2cd2f0d946$var$cdnFeatureFlag('binary');
        if ((0, $deNRp.isPathBasedEnabled)()) return (0, $deNRp.mapToPathBasedUrl)((0, $4lI5c.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $4HHlm.mapToMediaCdnUrl)((0, $4lI5c.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $3x2Xc.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
    	const cdnUrl = artifacts[artifactName]?.cdnUrl;
    	if (cdnUrl) {
    		return cdnUrl;
    	}
    } */ const artifactUrl = (0, $cMT0u.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $4HHlm.mapToMediaCdnUrl)((0, $4lI5c.createUrl)(`${auth.baseUrl}${artifactUrl}`, options), auth.token);
        if ((0, $deNRp.isPathBasedEnabled)()) return (0, $deNRp.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $55c1ab2cd2f0d946$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        let wmvParams = {};
        let authOptions = {
            authContext: {
                collectionName: params && params.collection
            }
        };
        if ((0, $dh538.fg)('confluence_watermark_admin_ui')) {
            const auth = await this.resolveAuth(authOptions.authContext);
            const wmv = (0, $46e8da9f0d2d6a2a$export$5296269cf74e58e)(auth.token);
            if (wmv) wmvParams = {
                wmv: wmv
            };
            authOptions = {
                resolvedAuth: auth
            };
        }
        const options = {
            ...metadata,
            ...authOptions,
            params: {
                ...$55c1ab2cd2f0d946$var$extendImageParams(params, fetchMaxRes),
                ...wmvParams
            },
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $4lI5c.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $55c1ab2cd2f0d946$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $55c1ab2cd2f0d946$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $3x2Xc.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $55c1ab2cd2f0d946$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $3x2Xc.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $4lI5c.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext, options) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const headers = {
            ...$55c1ab2cd2f0d946$var$jsonHeaders
        };
        if (options?.expectedFileSize !== undefined && (0, $dh538.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, requestOptions);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: // Contains collection name to write to
            params,
            // Contains collection name to write to
            headers: $55c1ab2cd2f0d946$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: // Contains collection name to read from
            traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext, clientId) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $55c1ab2cd2f0d946$var$jsonHeaders,
            body: JSON.stringify({
                id: id,
                clientId: clientId
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $4lI5c.defaultShouldRetryError)(err) || (0, $2ASLw.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $4lI5c.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $55c1ab2cd2f0d946$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $3HtSd.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $4lI5c.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $4HHlm.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $deNRp.isPathBasedEnabled)()) url = (0, $deNRp.mapToPathBasedUrl)(url);
        const response = await (0, $6Nh2I.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $55c1ab2cd2f0d946$var$setKeyValueInSessionStorage($55c1ab2cd2f0d946$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $55c1ab2cd2f0d946$var$setKeyValueInSessionStorage($55c1ab2cd2f0d946$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $6Nh2I.request)(url, {
            method: 'HEAD',
            traceContext: (0, $4lI5c.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
    constructor(config){
        this.config = config;
        this._chunkHashAlgorithm = void 0;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $3x2Xc.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $4lI5c.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $6Nh2I.request)(artifactUrl, options, abortController).then((0, $4lI5c.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $4lI5c.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $12f3d9e88ec42754$export$4b4cec3dcdfce972)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $12f3d9e88ec42754$export$5211e1371264aec3)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $9zykx.ChunkHashAlgorithm).Sha256;
    }
}
const $55c1ab2cd2f0d946$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $55c1ab2cd2f0d946$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $55c1ab2cd2f0d946$export$c8b741e18397852a = ()=>{
    return $55c1ab2cd2f0d946$var$getValueFromSessionStorage($55c1ab2cd2f0d946$var$MEDIA_API_ENVIRONMENT);
};
const $55c1ab2cd2f0d946$export$20f9315304dd6726 = ()=>{
    return $55c1ab2cd2f0d946$var$getValueFromSessionStorage($55c1ab2cd2f0d946$var$MEDIA_API_REGION);
};
module.exports["MediaStore"] = $55c1ab2cd2f0d946$export$572b8a2a9fd7cbba;
module.exports["getMediaEnvironment"] = $55c1ab2cd2f0d946$export$c8b741e18397852a;
module.exports["getMediaRegion"] = $55c1ab2cd2f0d946$export$20f9315304dd6726;

});

parcelRegister("3x2Xc", function(module, exports) {

var $I3W8S = parcelRequire("I3W8S");

const $ecc38b02c7960f61$export$860a16125e30000b = 'recents';
const $ecc38b02c7960f61$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $ecc38b02c7960f61$export$6e70f30e392bc53f = 4096;
const $ecc38b02c7960f61$export$c1abb8bab1e615cd = 5 * (0, $I3W8S.DATA_UNIT).MB;
const $ecc38b02c7960f61$export$3d5157f0def70e54 = 1000;
const $ecc38b02c7960f61$export$f14f521f3d306044 = 2 * (0, $I3W8S.DATA_UNIT).TB;
const $ecc38b02c7960f61$export$b3e78a9a23c941e9 = 'FileReaderError';
module.exports["RECENTS_COLLECTION"] = $ecc38b02c7960f61$export$860a16125e30000b;
module.exports["FILE_CACHE_MAX_AGE"] = $ecc38b02c7960f61$export$bd6e8fe09a90927b;
module.exports["MAX_RESOLUTION"] = $ecc38b02c7960f61$export$6e70f30e392bc53f;
module.exports["CHUNK_SIZE"] = $ecc38b02c7960f61$export$c1abb8bab1e615cd;
module.exports["PROCESSING_BATCH_SIZE"] = $ecc38b02c7960f61$export$3d5157f0def70e54;
module.exports["MAX_UPLOAD_FILE_SIZE"] = $ecc38b02c7960f61$export$f14f521f3d306044;
module.exports["FILE_READER_FALLBACK_ERROR_NAME"] = $ecc38b02c7960f61$export$b3e78a9a23c941e9;

});

parcelRegister("I3W8S", function(module, exports) {
const $db157f183e477061$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $db157f183e477061$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $db157f183e477061$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});
module.exports["isNotFoundMediaItemDetails"] = $db157f183e477061$export$fd27d7abbc4a746d;
module.exports["DATA_UNIT"] = $db157f183e477061$export$76cfea4c354af843;

});

parcelRegister("cMT0u", function(module, exports) {

var $4HHlm = parcelRequire("4HHlm");

const $ee477bcdf9a05252$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $4HHlm.isCDNEnabled)() && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};
module.exports["getArtifactUrl"] = $ee477bcdf9a05252$export$1cc24defa44e7f84;

});

parcelRegister("2ASLw", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");

class $88e3638e9e9f2690$export$43ee7d0e4f429743 extends (0, $dIgeg.BaseMediaClientError) {
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
}
function $88e3638e9e9f2690$export$3717b1ffef4428ea(err) {
    return err instanceof $88e3638e9e9f2690$export$43ee7d0e4f429743;
}
module.exports["RequestError"] = $88e3638e9e9f2690$export$43ee7d0e4f429743;
module.exports["isRequestError"] = $88e3638e9e9f2690$export$3717b1ffef4428ea;

});

parcelRegister("dIgeg", function(module, exports) {

var $7a3Fn = parcelRequire("7a3Fn");

class $03c4310d426dd637$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $03c4310d426dd637$export$e574d1724215079f extends $03c4310d426dd637$export$2b0aca14d61c3190 {
    get attributes() {
        return {
            reason: this.reason
        };
    }
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
}
function $03c4310d426dd637$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $03c4310d426dd637$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $03c4310d426dd637$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $03c4310d426dd637$export$e574d1724215079f(error?.reason || 'unknown-reason', error?.metadata, error?.innerError);
};
const $03c4310d426dd637$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};
module.exports["BaseMediaClientError"] = $03c4310d426dd637$export$2b0aca14d61c3190;
module.exports["CommonMediaClientError"] = $03c4310d426dd637$export$e574d1724215079f;
module.exports["isCommonMediaClientError"] = $03c4310d426dd637$export$881f0f9bc813e1f3;
module.exports["toCommonMediaClientError"] = $03c4310d426dd637$export$a5db89cfc88eff9;
module.exports["fromCommonMediaClientError"] = $03c4310d426dd637$export$c2b89b9a32286816;

});

parcelRegister("7a3Fn", function(module, exports) {
function $6acce91d0d416ce8$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $6acce91d0d416ce8$export$c15d72765ee2baa4(err) {
    return $6acce91d0d416ce8$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}
module.exports["getMediaClientErrorReason"] = $6acce91d0d416ce8$export$c15d72765ee2baa4;

});

parcelRegister("6Nh2I", function(module, exports) {

var $2ASLw = parcelRequire("2ASLw");


var $4lI5c = parcelRequire("4lI5c");


var $dh538 = parcelRequire("dh538");


var $deNRp = parcelRequire("deNRp");

var $ca85b04912cd4f2e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};


async function $8f4a328e663bdb9a$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $4lI5c.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $4lI5c.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $4lI5c.createProcessFetchResponse)(metadata));
    if ((0, $dh538.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            if ((0, $4lI5c.isFetchNetworkError)(err) && (0, $ca85b04912cd4f2e$export$2e2bcd8739ae039)()?.userAgent.includes('Edg/')) return false;
            return (0, $4lI5c.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $4lI5c.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            if ((0, $4lI5c.isFetchNetworkError)(error) && (0, $ca85b04912cd4f2e$export$2e2bcd8739ae039)()?.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $4lI5c.createUrl)((0, $deNRp.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $4lI5c.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $4lI5c.createProcessFetchResponse)(metadata));
                return (0, $4lI5c.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $4lI5c.fetchRetry)(doFetch, metadata, retryOptions);
}
module.exports["request"] = $8f4a328e663bdb9a$export$b5fe3f66a567bec0;

});

parcelRegister("fCrf0", function(module, exports) {
const $2afc4df937c16138$export$fce6876652108ab = (value)=>value === undefined;
const $2afc4df937c16138$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $2afc4df937c16138$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $2afc4df937c16138$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $2afc4df937c16138$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $2afc4df937c16138$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $2afc4df937c16138$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $2afc4df937c16138$var$getRandomHexValues(byte);
    }
    else randomHex = $2afc4df937c16138$var$getRandomHexValues(byte);
    return randomHex;
}
function $2afc4df937c16138$export$2e36de8639bad0ad() {
    return $2afc4df937c16138$export$456b25e3a9b4a843(8);
}
module.exports["isUndefined"] = $2afc4df937c16138$export$fce6876652108ab;
module.exports["omitBy"] = $2afc4df937c16138$export$d7a617dda645b4e3;
module.exports["getRandomHex"] = $2afc4df937c16138$export$456b25e3a9b4a843;
module.exports["getRandomTelemetryId"] = $2afc4df937c16138$export$2e36de8639bad0ad;

});

parcelRegister("eGqQQ", function(module, exports) {
parcelRequire("5vzpD");
var $dAAeA = parcelRequire("dAAeA");

const $a0541a92dc645483$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $dAAeA.mediaState).eventEmitter) (0, $dAAeA.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $dAAeA.mediaState).eventEmitter) (0, $dAAeA.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $dAAeA.mediaState).eventEmitter) return (0, $dAAeA.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};
module.exports["globalMediaEventEmitter"] = $a0541a92dc645483$export$68d003d3105952ad;

});

parcelRegister("fO7zn", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("eiASo")).FileFetcherError);

var $8v4h5 = parcelRequire("8v4h5");


var $2QGAA = parcelRequire("2QGAA");


var $cUcZ5 = parcelRequire("cUcZ5");

parcelRequire("5vzpD");
var $3HtSd = parcelRequire("3HtSd");


var $cxI7R = parcelRequire("cxI7R");


var $dfdbH = parcelRequire("dfdbH");


var $dPp8R = parcelRequire("dPp8R");


var $hZ6O7 = parcelRequire("hZ6O7");


var $I3W8S = parcelRequire("I3W8S");


var $eiASo = parcelRequire("eiASo");


var $5NXxU = parcelRequire("5NXxU");


var $iBgx8 = parcelRequire("iBgx8");


var $e2TX1 = parcelRequire("e2TX1");

var $7fac3439a83c441e$export$60f45028237c39d1;
"use strict";

var $2e4BA = parcelRequire("2e4BA");

$7fac3439a83c441e$export$60f45028237c39d1 = $2e4BA.PromiseObservable.create;


var $ab1d47c563367796$export$d02631cccf789723;
"use strict";

var $loLAD = parcelRequire("loLAD");

$ab1d47c563367796$export$d02631cccf789723 = $loLAD.RangeObservable.create;





const $eec64e16adc47add$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $ab1d47c563367796$export$d02631cccf789723)(0, totalChunks).pipe((0, $2QGAA.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};



var $YgydF = parcelRequire("YgydF");


var $XrDsM = parcelRequire("XrDsM");

async function $543454509056a935$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $543454509056a935$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $543454509056a935$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $YgydF.Observable)((sub)=>{
            notifiers.push($543454509056a935$var$notify(project(value), sub, onReady));
        });
};
const $543454509056a935$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $XrDsM.mergeMap)($543454509056a935$var$mapper(project), concurrent);


const $1ea4323a15240437$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $1ea4323a15240437$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $543454509056a935$export$707ee4c4c95d39e3)($1ea4323a15240437$export$28a452a485721473(hasher), concurrency)(blobs$);



const $f0ba4d0b9579dfef$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $543454509056a935$export$707ee4c4c95d39e3)(upload, options.concurrency));
};








const $9e167cc3b7b0d3f8$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $e2TX1.bufferCount)(options.batchSize)).pipe((0, $iBgx8.concatMap)(process));
};




var $gosUm = parcelRequire("gosUm");

const $bef8fade40e7e5ca$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $7fac3439a83c441e$export$60f45028237c39d1)((0, $543454509056a935$export$14e9cfd4a872cc1e)(file)).pipe((0, $iBgx8.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $eec64e16adc47add$export$5b92d769f2f57509)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $1ea4323a15240437$export$d5f5a550a38ec367)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f0ba4d0b9579dfef$export$94ce0f3fcf999415)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $5NXxU.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $9e167cc3b7b0d3f8$export$2f21790600302ed)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $iBgx8.concatMap)((batchedChunks)=>{
            return (0, $gosUm.from)(batchedChunks);
        }), (0, $e2TX1.bufferCount)(totalChunks));
    }));
const $bef8fade40e7e5ca$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $bef8fade40e7e5ca$export$88e80b3a0bb31f63(file, options, callbacks);
};








parcelRequire("5vzpD");
var $9zykx = parcelRequire("9zykx");

let $12ebecb6ac610d4e$var$hasher = null;
let $12ebecb6ac610d4e$var$sha256Hasher = null;
const $12ebecb6ac610d4e$export$d9c9d11cd648a505 = ()=>{
    $12ebecb6ac610d4e$var$hasher = null;
    $12ebecb6ac610d4e$var$sha256Hasher = null;
};


const $12ebecb6ac610d4e$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $9zykx.ChunkHashAlgorithm).Sha256) {
            if (!$12ebecb6ac610d4e$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("lRps8"));
                $12ebecb6ac610d4e$var$sha256Hasher = new SimpleHasher();
            }
            return $12ebecb6ac610d4e$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("de3Qv"));
    $12ebecb6ac610d4e$var$hasher = new SimpleHasher();
    return $12ebecb6ac610d4e$var$hasher;
};



var $dIgeg = parcelRequire("dIgeg");

class $f0819302df03bb30$export$515240c3f059c807 extends (0, $dIgeg.BaseMediaClientError) {
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        // Legacy Attribute. Should be removed
        this.id = void 0;
        this.id = metadata.id;
    }
}
function $f0819302df03bb30$export$80ee180172bc336(err) {
    return err instanceof $f0819302df03bb30$export$515240c3f059c807;
}



var $3x2Xc = parcelRequire("3x2Xc");







const $a1e018235d31d90e$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $a1e018235d31d90e$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $3x2Xc.MAX_UPLOAD_FILE_SIZE)) throw new Error($a1e018235d31d90e$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $I3W8S.DATA_UNIT).GB) return 5 * (0, $I3W8S.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $I3W8S.DATA_UNIT).GB && fileSize <= 50 * (0, $I3W8S.DATA_UNIT).GB) return 50 * (0, $I3W8S.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $I3W8S.DATA_UNIT).GB && fileSize <= 0.95 * (0, $I3W8S.DATA_UNIT).TB) return 100 * (0, $I3W8S.DATA_UNIT).MB;
    return 210 * (0, $I3W8S.DATA_UNIT).MB;
};


const $f7b7bf2de9b893f8$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $12ebecb6ac610d4e$export$14b114effbc08b6b)(hashAlgorithm);
    return hasher.hash(blob);
};
const $f7b7bf2de9b893f8$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $f7b7bf2de9b893f8$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext, size)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $f7b7bf2de9b893f8$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext, {
            expectedFileSize: size
        });
        offset += chunks.length;
    };
};
const $f7b7bf2de9b893f8$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext, {
        expectedFileSize: file.size
    });
};
const $f7b7bf2de9b893f8$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $3x2Xc.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $a1e018235d31d90e$export$71f452e02035c1e2)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $a1e018235d31d90e$export$b36239e4c33c2902)) callbacks?.onUploadFinish(new (0, $f0819302df03bb30$export$515240c3f059c807)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $bef8fade40e7e5ca$export$9ab6bef3838698f8)(content, {
        hashingFunction: (blob)=>$f7b7bf2de9b893f8$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $f7b7bf2de9b893f8$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $3x2Xc.PROCESSING_BATCH_SIZE),
        processingFunction: $f7b7bf2de9b893f8$var$createProcessingFunction(store, deferredUploadId, collection, traceContext, file.size)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $gosUm.from)(deferredUploadId).pipe((0, $iBgx8.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $iBgx8.concatMap)(()=>(0, $gosUm.from)($f7b7bf2de9b893f8$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $f7b7bf2de9b893f8$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);



var $4vGex = parcelRequire("4vGex");


var $eGqQQ = parcelRequire("eGqQQ");





var $3vFPy = parcelRequire("3vFPy");


var $24z7I = parcelRequire("24z7I");

const $8b9bf6fad8142f87$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $24z7I.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};





const $cec4acf3fca7f74c$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $hZ6O7.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};


const $bbc0fff7d29b42a2$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};



var $3iVuE = parcelRequire("3iVuE");

function $192b166d2dca49da$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $192b166d2dca49da$export$8659d1f07d151381(item) {
    return $192b166d2dca49da$export$4b2432e2d8723823((0, $3iVuE.createMediaSubject)(item));
}




const $59ace0a3fef2878e$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $8v4h5.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));



var $ezhv2 = parcelRequire("ezhv2");








var $kSxxi = parcelRequire("kSxxi");


var $5h2n5 = parcelRequire("5h2n5");


var $ld7ZZ = parcelRequire("ld7ZZ");

parcelRequire("9EPd0");
var $eUfuX = parcelRequire("eUfuX");


var $1bFdN = parcelRequire("1bFdN");


var $fCrf0 = parcelRequire("fCrf0");

const $a372dd946c5395fb$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $a372dd946c5395fb$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $fCrf0.getRandomTelemetryId)(),
                spanId: (0, $fCrf0.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $a372dd946c5395fb$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))($a372dd946c5395fb$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $a372dd946c5395fb$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}



var $4lI5c = parcelRequire("4lI5c");




const $2b04009c216f777e$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $2b04009c216f777e$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $2b04009c216f777e$export$fe17eabf77aabacb {
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh, initialFileState: initialFileState } = options;
        if (!(0, $cxI7R.isValidUuid)(id)) {
            // Do NOT pass initialFileState here — for an invalid UUID the SSR seed
            // is meaningless and would cause subscribers to briefly see a
            // valid-looking file state before the error is emitted.
            const subject = (0, $3iVuE.createMediaSubject)();
            const err = new (0, $eiASo.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $192b166d2dca49da$export$4b2432e2d8723823)(subject);
        }
        if (forceRefresh) (0, $4vGex.getFileStreamsCache)().remove(id);
        return (0, $192b166d2dca49da$export$4b2432e2d8723823)((0, $4vGex.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh, initialFileState);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $59ace0a3fef2878e$export$4dbaaf6c79705e6c)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge, name) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge, name);
    }
    touchFiles(descriptors, collection, traceContext, expectedFileSize) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext, {
            expectedFileSize: expectedFileSize
        }).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext, expectedFileSize) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext, expectedFileSize).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext, anonymizeFilename) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $3iVuE.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = anonymizeFilename ? crypto.randomUUID() : url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $4vGex.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $24z7I.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $ezhv2.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext, file.size);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $3iVuE.createMediaSubject)();
        (0, $4vGex.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $8v4h5.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $2QGAA.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $cec4acf3fca7f74c$export$89097c0ec1e0dee1)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $f7b7bf2de9b893f8$export$a5575dbeeffdad98)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $192b166d2dca49da$export$4b2432e2d8723823)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName, undefined, name);
        (0, $dfdbH.downloadUrl)(url, {
            name: name
        });
        (0, $eGqQQ.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $3x2Xc.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $4lI5c.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $dPp8R.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $3HtSd.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext, source.clientId);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $4vGex.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($2b04009c216f777e$var$isCopySourceFileWithToken(source) && $2b04009c216f777e$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $24z7I.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $hZ6O7.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $3iVuE.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $hZ6O7.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $hZ6O7.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $kSxxi.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $cec4acf3fca7f74c$export$89097c0ec1e0dee1)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $cec4acf3fca7f74c$export$89097c0ec1e0dee1)(remoteFileState, mediaType),
                            ...!(0, $hZ6O7.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $hZ6O7.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $hZ6O7.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $4vGex.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $3iVuE.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
    constructor(mediaApi, store = (0, $eUfuX.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.dataloader = void 0;
        this.copyIntentRegisterationBatcher = void 0;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $dIgeg.isCommonMediaClientError)(error)) return (0, $dIgeg.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $dIgeg.CommonMediaClientError)(error);
                return (0, $dIgeg.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $dIgeg.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $dIgeg.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh, initialFileState)=>{
            const subject = (0, $3iVuE.createMediaSubject)(initialFileState);
            const poll = new (0, $5h2n5.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (!forceRefresh && initialFileState?.status === 'processed') {
                    subject.complete();
                    return;
                }
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $I3W8S.isNotFoundMediaItemDetails)(response)) throw new (0, $eiASo.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $ld7ZZ.isEmptyFile)(response)) throw new (0, $eiASo.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $hZ6O7.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $bbc0fff7d29b42a2$export$ed17558b11b88056)(file.content);
            const { content: content, name: name = '' // name property is not available in base64 image
             } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $8b9bf6fad8142f87$export$ac3214931ffd82af)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $hZ6O7.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if ('mediaMetadata' in fileState && fileState.mediaMetadata?.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch  {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $3vFPy.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $a372dd946c5395fb$export$57945b6819e39246)(mediaApi);
    }
}
module.exports["FileFetcherImpl"] = $2b04009c216f777e$export$fe17eabf77aabacb;

});

parcelRegister("8v4h5", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $630488cd7ba03835$export$f55210826850c514, (v) => $630488cd7ba03835$export$f55210826850c514 = v);
var $630488cd7ba03835$export$f55210826850c514;
"use strict";

var $fvPwd = parcelRequire("fvPwd");


var $1SUM9 = parcelRequire("1SUM9");


var $bEhXH = parcelRequire("bEhXH");


var $3FcLR = parcelRequire("3FcLR");


var $6LPWz = parcelRequire("6LPWz");


var $jbEVV = parcelRequire("jbEVV");

/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $630488cd7ba03835$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($bEhXH.isFunction(_unsubscribe)) {
            var trial = $3FcLR.tryCatch(_unsubscribe).call(this);
            if (trial === $6LPWz.errorObject) {
                hasErrors = true;
                errors = errors || ($6LPWz.errorObject.e instanceof $jbEVV.UnsubscriptionError ? $630488cd7ba03835$var$flattenUnsubscriptionErrors($6LPWz.errorObject.e.errors) : [
                    $6LPWz.errorObject.e
                ]);
            }
        }
        if ($fvPwd.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($1SUM9.isObject(sub)) {
                    var trial = $3FcLR.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $6LPWz.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $6LPWz.errorObject.e;
                        if (err instanceof $jbEVV.UnsubscriptionError) errors = errors.concat($630488cd7ba03835$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $jbEVV.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$630488cd7ba03835$export$f55210826850c514 = $630488cd7ba03835$var$Subscription;
function $630488cd7ba03835$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $jbEVV.UnsubscriptionError ? err.errors : err);
    }, []);
}

});

parcelRegister("fvPwd", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $b4b1b6cb5f25b817$export$43bee75e5e14138e, (v) => $b4b1b6cb5f25b817$export$43bee75e5e14138e = v);
var $b4b1b6cb5f25b817$export$43bee75e5e14138e;
"use strict";
$b4b1b6cb5f25b817$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("bEhXH", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $87b15d0289dc4480$export$f6e2535fb5126e54, (v) => $87b15d0289dc4480$export$f6e2535fb5126e54 = v);
var $87b15d0289dc4480$export$f6e2535fb5126e54;
"use strict";
function $87b15d0289dc4480$var$isFunction(x) {
    return typeof x === 'function';
}
$87b15d0289dc4480$export$f6e2535fb5126e54 = $87b15d0289dc4480$var$isFunction;

});

parcelRegister("3FcLR", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $2aaf1b7b9e6a0b43$export$d234c058d1d4e435, (v) => $2aaf1b7b9e6a0b43$export$d234c058d1d4e435 = v);
var $2aaf1b7b9e6a0b43$export$d234c058d1d4e435;
"use strict";

var $6LPWz = parcelRequire("6LPWz");

var $2aaf1b7b9e6a0b43$var$tryCatchTarget;
function $2aaf1b7b9e6a0b43$var$tryCatcher() {
    try {
        return $2aaf1b7b9e6a0b43$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $6LPWz.errorObject.e = e;
        return $6LPWz.errorObject;
    }
}
function $2aaf1b7b9e6a0b43$var$tryCatch(fn) {
    $2aaf1b7b9e6a0b43$var$tryCatchTarget = fn;
    return $2aaf1b7b9e6a0b43$var$tryCatcher;
}
$2aaf1b7b9e6a0b43$export$d234c058d1d4e435 = $2aaf1b7b9e6a0b43$var$tryCatch;

});

parcelRegister("6LPWz", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $4edf6cca87500c0a$export$fc504b39d7c1176, (v) => $4edf6cca87500c0a$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $4edf6cca87500c0a$export$fc504b39d7c1176;
"use strict";
$4edf6cca87500c0a$export$fc504b39d7c1176 = {
    e: {}
};

});

parcelRegister("2QGAA", function(module, exports) {
"use strict";
var $2131796d8998b656$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $2131796d8998b656$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $2131796d8998b656$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $2131796d8998b656$var$map;
var $2131796d8998b656$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2131796d8998b656$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $2131796d8998b656$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2131796d8998b656$var$MapSubscriber = function(_super) {
    $2131796d8998b656$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($axeml.Subscriber);

});

parcelRegister("axeml", function(module, exports) {
"use strict";
var $7ab81fecc3d02f79$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $bEhXH = parcelRequire("bEhXH");


var $8v4h5 = parcelRequire("8v4h5");


var $kmYd0 = parcelRequire("kmYd0");


var $1GCxN = parcelRequire("1GCxN");

/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $7ab81fecc3d02f79$var$Subscriber = function(_super) {
    $7ab81fecc3d02f79$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $kmYd0.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $kmYd0.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($7ab81fecc3d02f79$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$1GCxN.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $7ab81fecc3d02f79$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $7ab81fecc3d02f79$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$1GCxN.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($8v4h5.Subscription);
module.exports.Subscriber = $7ab81fecc3d02f79$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7ab81fecc3d02f79$var$SafeSubscriber = function(_super) {
    $7ab81fecc3d02f79$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($bEhXH.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $kmYd0.empty) {
                context = Object.create(observerOrNext);
                if ($bEhXH.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($7ab81fecc3d02f79$var$Subscriber);
function $7ab81fecc3d02f79$var$isTrustedSubscriber(obj) {
    return obj instanceof $7ab81fecc3d02f79$var$Subscriber || 'syncErrorThrowable' in obj && obj[$1GCxN.rxSubscriber];
}

});

parcelRegister("4iRIL", function(module, exports) {
$parcel$export(module.exports, "root", () => $322283b769ed4d8b$export$e8e78c978b129247, (v) => $322283b769ed4d8b$export$e8e78c978b129247 = v);
var $322283b769ed4d8b$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $322283b769ed4d8b$var$__window = typeof window !== 'undefined' && window;
var $322283b769ed4d8b$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $322283b769ed4d8b$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $322283b769ed4d8b$var$_root = $322283b769ed4d8b$var$__window || $322283b769ed4d8b$var$__global || $322283b769ed4d8b$var$__self;
$322283b769ed4d8b$export$e8e78c978b129247 = $322283b769ed4d8b$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$322283b769ed4d8b$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});

parcelRegister("cxI7R", function(module, exports) {
const $7b09d2a6a77303d4$var$BASIC_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $7b09d2a6a77303d4$export$6ad459db9a6bcc76 = (value)=>{
    if (typeof value !== 'string') return false;
    const normalizedValue = value.toLowerCase();
    if (!$7b09d2a6a77303d4$var$BASIC_UUID_REGEX.test(normalizedValue)) return false;
    const version = normalizedValue[14];
    if (version === '1' || version === '2') return true;
    if (version === '3' || version === '4' || version === '5') {
        const variant = normalizedValue[19];
        return variant === '8' || variant === '9' || variant === 'a' || variant === 'b';
    }
    return false;
};
module.exports["isValidUuid"] = $7b09d2a6a77303d4$export$6ad459db9a6bcc76;

});

parcelRegister("dfdbH", function(module, exports) {
const $2a11df016fa68995$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
module.exports["downloadUrl"] = $2a11df016fa68995$export$8a96edb1c96563f4;

});

parcelRegister("hZ6O7", function(module, exports) {
const $251840e6120a21b3$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $251840e6120a21b3$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $251840e6120a21b3$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $251840e6120a21b3$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $251840e6120a21b3$export$92dd692b31e42e64 = (fileState)=>!$251840e6120a21b3$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $251840e6120a21b3$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $251840e6120a21b3$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $251840e6120a21b3$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $251840e6120a21b3$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $251840e6120a21b3$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata, failReason: failReason, previewCdnUrl: previewCdnUrl } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata,
        previewCdnUrl: previewCdnUrl
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing',
                failReason: failReason
            };
    }
};
const $251840e6120a21b3$export$ea3730792e8bebfb = (id, item)=>{
    return $251840e6120a21b3$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};
module.exports["isUploadingFileState"] = $251840e6120a21b3$export$70eb3481b487c668;
module.exports["isProcessingFileState"] = $251840e6120a21b3$export$5c30e6dd75278e66;
module.exports["isProcessedFileState"] = $251840e6120a21b3$export$1d17291aafa5f231;
module.exports["isErrorFileState"] = $251840e6120a21b3$export$f863e1e09c8a926;
module.exports["isFinalFileState"] = $251840e6120a21b3$export$270b3fc27120edd0;
module.exports["isNonErrorFinalFileState"] = $251840e6120a21b3$export$8f33148a37b0c72f;
module.exports["hasArtifacts"] = $251840e6120a21b3$export$ecdf3dee1d148302;
module.exports["isImageRepresentationReady"] = $251840e6120a21b3$export$4e33ccde53b4f0bf;
module.exports["mapMediaFileToFileState"] = $251840e6120a21b3$export$ddfd67d20657322f;
module.exports["mapMediaItemToFileState"] = $251840e6120a21b3$export$ea3730792e8bebfb;

});

parcelRegister("5NXxU", function(module, exports) {
"use strict";
var $439fb7ed7e7c5d55$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $439fb7ed7e7c5d55$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $439fb7ed7e7c5d55$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $439fb7ed7e7c5d55$var$tap;
var $439fb7ed7e7c5d55$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $439fb7ed7e7c5d55$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $439fb7ed7e7c5d55$var$DoSubscriber = function(_super) {
    $439fb7ed7e7c5d55$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $axeml.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($axeml.Subscriber);

});

parcelRegister("iBgx8", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $d8a881e2f7549657$export$c28c8388be0ab31a, (v) => $d8a881e2f7549657$export$c28c8388be0ab31a = v);
var $d8a881e2f7549657$export$c28c8388be0ab31a;
"use strict";

var $XrDsM = parcelRequire("XrDsM");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $d8a881e2f7549657$var$concatMap(project, resultSelector) {
    return $XrDsM.mergeMap(project, resultSelector, 1);
}
$d8a881e2f7549657$export$c28c8388be0ab31a = $d8a881e2f7549657$var$concatMap;

});

parcelRegister("XrDsM", function(module, exports) {
"use strict";
var $0b2af2a344c9fb3a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $dZ9AU = parcelRequire("dZ9AU");


var $iwB6M = parcelRequire("iwB6M");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $0b2af2a344c9fb3a$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $0b2af2a344c9fb3a$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $0b2af2a344c9fb3a$var$mergeMap;
var $0b2af2a344c9fb3a$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0b2af2a344c9fb3a$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $0b2af2a344c9fb3a$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0b2af2a344c9fb3a$var$MergeMapSubscriber = function(_super) {
    $0b2af2a344c9fb3a$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($dZ9AU.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($iwB6M.OuterSubscriber);
module.exports.MergeMapSubscriber = $0b2af2a344c9fb3a$var$MergeMapSubscriber;

});

parcelRegister("dZ9AU", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $a2e86a1a6716d252$export$d0604af3321cfb1b, (v) => $a2e86a1a6716d252$export$d0604af3321cfb1b = v);
var $a2e86a1a6716d252$export$d0604af3321cfb1b;
"use strict";

var $4iRIL = parcelRequire("4iRIL");


var $2RoPK = parcelRequire("2RoPK");


var $lggQy = parcelRequire("lggQy");


var $1SUM9 = parcelRequire("1SUM9");


var $YgydF = parcelRequire("YgydF");


var $kNaF1 = parcelRequire("kNaF1");


var $lLPMj = parcelRequire("lLPMj");


var $1v1oG = parcelRequire("1v1oG");

function $a2e86a1a6716d252$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $lLPMj.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $YgydF.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($2RoPK.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($lggQy.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $4iRIL.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$kNaF1.iterator] === 'function') {
        var iterator = result[$kNaF1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$1v1oG.observable] === 'function') {
        var obs = result[$1v1oG.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $lLPMj.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $1SUM9.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$a2e86a1a6716d252$export$d0604af3321cfb1b = $a2e86a1a6716d252$var$subscribeToResult;

});

parcelRegister("YgydF", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $0b52716166cb5834$export$77cea355fa80b5f4, (v) => $0b52716166cb5834$export$77cea355fa80b5f4 = v);
var $0b52716166cb5834$export$77cea355fa80b5f4;
"use strict";

var $4iRIL = parcelRequire("4iRIL");

var $56222ff57d5613a4$export$2a12c2cebbfd1087;
"use strict";

var $axeml = parcelRequire("axeml");


var $1GCxN = parcelRequire("1GCxN");


var $kmYd0 = parcelRequire("kmYd0");

function $56222ff57d5613a4$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $axeml.Subscriber) return nextOrObserver;
        if (nextOrObserver[$1GCxN.rxSubscriber]) return nextOrObserver[$1GCxN.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $axeml.Subscriber($kmYd0.empty);
    return new $axeml.Subscriber(nextOrObserver, error, complete);
}
$56222ff57d5613a4$export$2a12c2cebbfd1087 = $56222ff57d5613a4$var$toSubscriber;



var $1v1oG = parcelRequire("1v1oG");


var $5wWzN = parcelRequire("5wWzN");

/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $0b52716166cb5834$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $56222ff57d5613a4$export$2a12c2cebbfd1087(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($4iRIL.root.Rx && $4iRIL.root.Rx.config && $4iRIL.root.Rx.config.Promise) PromiseCtor = $4iRIL.root.Rx.config.Promise;
            else if ($4iRIL.root.Promise) PromiseCtor = $4iRIL.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$1v1oG.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $5wWzN.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($4iRIL.root.Rx && $4iRIL.root.Rx.config && $4iRIL.root.Rx.config.Promise) PromiseCtor = $4iRIL.root.Rx.config.Promise;
            else if ($4iRIL.root.Promise) PromiseCtor = $4iRIL.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$0b52716166cb5834$export$77cea355fa80b5f4 = $0b52716166cb5834$var$Observable;

});

parcelRegister("5wWzN", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $406d60f5575d7a0f$export$a4627e546088548d, (v) => $406d60f5575d7a0f$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $406d60f5575d7a0f$export$71f88a61afaa14d7, (v) => $406d60f5575d7a0f$export$71f88a61afaa14d7 = v);
var $406d60f5575d7a0f$export$a4627e546088548d;
var $406d60f5575d7a0f$export$71f88a61afaa14d7;
"use strict";

var $6qxzH = parcelRequire("6qxzH");

/* tslint:enable:max-line-length */ function $406d60f5575d7a0f$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $406d60f5575d7a0f$var$pipeFromArray(fns);
}
$406d60f5575d7a0f$export$a4627e546088548d = $406d60f5575d7a0f$var$pipe;
/* @internal */ function $406d60f5575d7a0f$var$pipeFromArray(fns) {
    if (!fns) return $6qxzH.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$406d60f5575d7a0f$export$71f88a61afaa14d7 = $406d60f5575d7a0f$var$pipeFromArray;

});

parcelRegister("6qxzH", function(module, exports) {
$parcel$export(module.exports, "noop", () => $4adf37099bdd3a30$export$8793edee2d425525, (v) => $4adf37099bdd3a30$export$8793edee2d425525 = v);
var $4adf37099bdd3a30$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $4adf37099bdd3a30$var$noop() {}
$4adf37099bdd3a30$export$8793edee2d425525 = $4adf37099bdd3a30$var$noop;

});

parcelRegister("kNaF1", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $f230a7381f79ecc2$export$6f58e2338da23f4d, (v) => $f230a7381f79ecc2$export$6f58e2338da23f4d = v);
var $f230a7381f79ecc2$export$77b88d321d1c84c6;
var $f230a7381f79ecc2$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $f230a7381f79ecc2$export$9785f547d3164dac;
"use strict";

var $4iRIL = parcelRequire("4iRIL");

function $f230a7381f79ecc2$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$f230a7381f79ecc2$export$77b88d321d1c84c6 = $f230a7381f79ecc2$var$symbolIteratorPonyfill;
$f230a7381f79ecc2$export$6f58e2338da23f4d = $f230a7381f79ecc2$var$symbolIteratorPonyfill($4iRIL.root);
$f230a7381f79ecc2$export$9785f547d3164dac = $f230a7381f79ecc2$export$6f58e2338da23f4d;

});

parcelRegister("iwB6M", function(module, exports) {
"use strict";
var $d7c800161adcf658$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d7c800161adcf658$var$OuterSubscriber = function(_super) {
    $d7c800161adcf658$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($axeml.Subscriber);
module.exports.OuterSubscriber = $d7c800161adcf658$var$OuterSubscriber;

});

parcelRegister("e2TX1", function(module, exports) {
"use strict";
var $a39ca7450b7b5bd3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $a39ca7450b7b5bd3$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $a39ca7450b7b5bd3$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $a39ca7450b7b5bd3$var$bufferCount;
var $a39ca7450b7b5bd3$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $a39ca7450b7b5bd3$var$BufferCountSubscriber;
        else this.subscriberClass = $a39ca7450b7b5bd3$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a39ca7450b7b5bd3$var$BufferCountSubscriber = function(_super) {
    $a39ca7450b7b5bd3$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($axeml.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a39ca7450b7b5bd3$var$BufferSkipCountSubscriber = function(_super) {
    $a39ca7450b7b5bd3$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($axeml.Subscriber);

});

parcelRegister("gosUm", function(module, exports) {
$parcel$export(module.exports, "from", () => $bef54fca9b1e0652$export$6788812c4e6611e6, (v) => $bef54fca9b1e0652$export$6788812c4e6611e6 = v);
var $bef54fca9b1e0652$export$6788812c4e6611e6;
"use strict";

var $e3P0W = parcelRequire("e3P0W");

$bef54fca9b1e0652$export$6788812c4e6611e6 = $e3P0W.FromObservable.create;

});

parcelRegister("e3P0W", function(module, exports) {
"use strict";
var $a3c8eae00d368aab$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fvPwd = parcelRequire("fvPwd");


var $2RoPK = parcelRequire("2RoPK");


var $lggQy = parcelRequire("lggQy");


var $2e4BA = parcelRequire("2e4BA");


var $ufz07 = parcelRequire("ufz07");


var $HHFyQ = parcelRequire("HHFyQ");


var $lCIqm = parcelRequire("lCIqm");


var $kNaF1 = parcelRequire("kNaF1");


var $YgydF = parcelRequire("YgydF");


var $jHUX7 = parcelRequire("jHUX7");


var $1v1oG = parcelRequire("1v1oG");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a3c8eae00d368aab$var$FromObservable = function(_super) {
    $a3c8eae00d368aab$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$1v1oG.observable] === 'function') {
                if (ish instanceof $YgydF.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($fvPwd.isArray(ish)) return new $HHFyQ.ArrayObservable(ish, scheduler);
            else if ($lggQy.isPromise(ish)) return new $2e4BA.PromiseObservable(ish, scheduler);
            else if (typeof ish[$kNaF1.iterator] === 'function' || typeof ish === 'string') return new $ufz07.IteratorObservable(ish, scheduler);
            else if ($2RoPK.isArrayLike(ish)) return new $lCIqm.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$1v1oG.observable]().subscribe(subscriber);
        else return ish[$1v1oG.observable]().subscribe(new $jHUX7.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($YgydF.Observable);
module.exports.FromObservable = $a3c8eae00d368aab$var$FromObservable;

});

parcelRegister("HHFyQ", function(module, exports) {
"use strict";
var $0835e416a554ad48$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $YgydF = parcelRequire("YgydF");


var $5OUhL = parcelRequire("5OUhL");


var $b5CQv = parcelRequire("b5CQv");


var $5Dgek = parcelRequire("5Dgek");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $0835e416a554ad48$var$ArrayObservable = function(_super) {
    $0835e416a554ad48$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($5Dgek.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $5OUhL.ScalarObservable(array[0], scheduler);
        else return new $b5CQv.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($YgydF.Observable);
module.exports.ArrayObservable = $0835e416a554ad48$var$ArrayObservable;

});

parcelRegister("5OUhL", function(module, exports) {
"use strict";
var $43cd485ff87706c1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $YgydF = parcelRequire("YgydF");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $43cd485ff87706c1$var$ScalarObservable = function(_super) {
    $43cd485ff87706c1$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($YgydF.Observable);
module.exports.ScalarObservable = $43cd485ff87706c1$var$ScalarObservable;

});

parcelRegister("b5CQv", function(module, exports) {
"use strict";
var $812e4b51746b98b3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $YgydF = parcelRequire("YgydF");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $812e4b51746b98b3$var$EmptyObservable = function(_super) {
    $812e4b51746b98b3$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($YgydF.Observable);
module.exports.EmptyObservable = $812e4b51746b98b3$var$EmptyObservable;

});

parcelRegister("5Dgek", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $419d2f3565303e24$export$187e35932e88c15c, (v) => $419d2f3565303e24$export$187e35932e88c15c = v);
var $419d2f3565303e24$export$187e35932e88c15c;
"use strict";
function $419d2f3565303e24$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$419d2f3565303e24$export$187e35932e88c15c = $419d2f3565303e24$var$isScheduler;

});

parcelRegister("jHUX7", function(module, exports) {
"use strict";
var $e58e360da0b32f62$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");


var $6j5QO = parcelRequire("6j5QO");

/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $e58e360da0b32f62$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $e58e360da0b32f62$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $e58e360da0b32f62$var$observeOn;
var $e58e360da0b32f62$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e58e360da0b32f62$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $e58e360da0b32f62$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e58e360da0b32f62$var$ObserveOnSubscriber = function(_super) {
    $e58e360da0b32f62$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $e58e360da0b32f62$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($6j5QO.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($6j5QO.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($6j5QO.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($axeml.Subscriber);
module.exports.ObserveOnSubscriber = $e58e360da0b32f62$var$ObserveOnSubscriber;
var $e58e360da0b32f62$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $e58e360da0b32f62$var$ObserveOnMessage;

});

parcelRegister("6j5QO", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $49790e46841c81ff$export$14834abbfce3b8cd, (v) => $49790e46841c81ff$export$14834abbfce3b8cd = v);
var $49790e46841c81ff$export$14834abbfce3b8cd;
"use strict";

var $YgydF = parcelRequire("YgydF");

/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $49790e46841c81ff$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $YgydF.Observable.of(this.value);
            case 'E':
                return $YgydF.Observable.throw(this.error);
            case 'C':
                return $YgydF.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$49790e46841c81ff$export$14834abbfce3b8cd = $49790e46841c81ff$var$Notification;

});

parcelRegister("lRps8", function(module, exports) {

let $fea24a9bb08bc3f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fea24a9bb08bc3f3$var$load("bLm2D"),
    $fea24a9bb08bc3f3$var$load("dXN7B")
]).then(()=>parcelRequire('lzjf5'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("de3Qv", function(module, exports) {

let $9a0f90e4fe80fee5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9a0f90e4fe80fee5$var$load("coUzl"),
    $9a0f90e4fe80fee5$var$load("5nMTY"),
    $9a0f90e4fe80fee5$var$load("tLGOl")
]).then(()=>parcelRequire('anKEx'));

});

parcelRegister("4vGex", function(module, exports) {
class $3cc091f0ee85de9c$export$4293896e79732236 {
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
    constructor(streams){
        this.streams = streams;
    }
}
let $3cc091f0ee85de9c$var$streamCache;

const $3cc091f0ee85de9c$export$f2f061938c1e6810 = ()=>{
    if (!$3cc091f0ee85de9c$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("dAAeA")).mediaState;
        $3cc091f0ee85de9c$var$streamCache = new $3cc091f0ee85de9c$export$4293896e79732236(mediaState.streams);
    }
    return $3cc091f0ee85de9c$var$streamCache;
};
module.exports["getFileStreamsCache"] = $3cc091f0ee85de9c$export$f2f061938c1e6810;

});

parcelRegister("3vFPy", function(module, exports) {

var $1bFdN = parcelRequire("1bFdN");


var $fCrf0 = parcelRequire("fCrf0");

const $e302ef62d3d3242b$export$b79d95ee17a87a = 100;
const $e302ef62d3d3242b$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $e302ef62d3d3242b$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $e302ef62d3d3242b$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $e302ef62d3d3242b$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $e302ef62d3d3242b$var$makeCacheKey(id, collection);
        if ($e302ef62d3d3242b$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($e302ef62d3d3242b$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $e302ef62d3d3242b$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $e302ef62d3d3242b$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $fCrf0.getRandomTelemetryId)(),
                spanId: (0, $fCrf0.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $e302ef62d3d3242b$export$71cd2e8f8162d47b(keys, items);
    };
}
function $e302ef62d3d3242b$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))($e302ef62d3d3242b$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $e302ef62d3d3242b$export$b79d95ee17a87a
    });
}
module.exports["createFileDataloader"] = $e302ef62d3d3242b$export$ae188fee39529b82;

});

parcelRegister("24z7I", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("JXmwv")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("JXmwv")).isVideoMimeTypeSupportedByBrowser);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $eff9c5d43b4c343b$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;



var $JXmwv = parcelRequire("JXmwv");


var $6rtaQ = parcelRequire("6rtaQ");


var $dbSkL = parcelRequire("dbSkL");

const $3f7416d30cd6058a$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $eff9c5d43b4c343b$export$f47f3fe506e20fe6)(mimeType)) return 'archive';
    if ((0, $JXmwv.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $6rtaQ.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $JXmwv.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $6rtaQ.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $JXmwv.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $6rtaQ.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $JXmwv.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $6rtaQ.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};
module.exports["getMediaTypeFromMimeType"] = $3f7416d30cd6058a$export$79e1dc0d1801e8ef;

});

parcelRegister("JXmwv", function(module, exports) {
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $defc805078ee9b36$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $defc805078ee9b36$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $defc805078ee9b36$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $defc805078ee9b36$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $defc805078ee9b36$export$55ca6cdaf6093034 = (mimeType)=>$defc805078ee9b36$export$74325e3c843a9555(mimeType) || $defc805078ee9b36$export$c021f2623a75015f(mimeType) || $defc805078ee9b36$export$ff36075ea755a717(mimeType) || $defc805078ee9b36$export$87bf945cf31ec2d9(mimeType);
module.exports["isImageMimeTypeSupportedByBrowser"] = $defc805078ee9b36$export$c021f2623a75015f;
module.exports["isDocumentMimeTypeSupportedByBrowser"] = $defc805078ee9b36$export$74325e3c843a9555;
module.exports["isAudioMimeTypeSupportedByBrowser"] = $defc805078ee9b36$export$ff36075ea755a717;
module.exports["isVideoMimeTypeSupportedByBrowser"] = $defc805078ee9b36$export$87bf945cf31ec2d9;
module.exports["isMimeTypeSupportedByBrowser"] = $defc805078ee9b36$export$55ca6cdaf6093034;

});

parcelRegister("dbSkL", function(module, exports) {
// MS Excel MIME types — covers all native Microsoft spreadsheet formats.
// Stored in their canonical form (RFC 4288 mimetypes are case-sensitive;
// the media backend always sends them in this exact casing).
const $2120ed83be592dc2$var$EXCEL_MIME_TYPES = new Set([
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12'
]);
const $2120ed83be592dc2$export$e5fbc944c6f94589 = (mimeType)=>$2120ed83be592dc2$var$EXCEL_MIME_TYPES.has(mimeType);
module.exports["isExcelFile"] = $2120ed83be592dc2$export$e5fbc944c6f94589;

});

parcelRegister("3iVuE", function(module, exports) {

var $jXDcc = parcelRequire("jXDcc");

function $652e2ad2a32f0daf$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $jXDcc.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}
module.exports["createMediaSubject"] = $652e2ad2a32f0daf$export$bc76d51553fa5e35;

});

parcelRegister("jXDcc", function(module, exports) {
"use strict";
var $e881ee7dfac11ed0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $augeV = parcelRequire("augeV");

/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $539817c1835f128f$export$4f7fa46ff53e516f;
"use strict";

var $74JhH = parcelRequire("74JhH");


var $1qr9n = parcelRequire("1qr9n");

$539817c1835f128f$export$4f7fa46ff53e516f = new $1qr9n.QueueScheduler($74JhH.QueueAction);



var $8v4h5 = parcelRequire("8v4h5");


var $jHUX7 = parcelRequire("jHUX7");


var $bGuMq = parcelRequire("bGuMq");


var $lQpfG = parcelRequire("lQpfG");

/**
 * @class ReplaySubject<T>
 */ var $e881ee7dfac11ed0$var$ReplaySubject = function(_super) {
    $e881ee7dfac11ed0$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $e881ee7dfac11ed0$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $8v4h5.Subscription.EMPTY;
        else if (this.isStopped) subscription = $8v4h5.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $lQpfG.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $jHUX7.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $539817c1835f128f$export$4f7fa46ff53e516f).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($augeV.Subject);
module.exports.ReplaySubject = $e881ee7dfac11ed0$var$ReplaySubject;
var $e881ee7dfac11ed0$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});

parcelRegister("augeV", function(module, exports) {
"use strict";
var $7a294d96e9d5a186$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $YgydF = parcelRequire("YgydF");


var $axeml = parcelRequire("axeml");


var $8v4h5 = parcelRequire("8v4h5");


var $bGuMq = parcelRequire("bGuMq");


var $lQpfG = parcelRequire("lQpfG");


var $1GCxN = parcelRequire("1GCxN");

/**
 * @class SubjectSubscriber<T>
 */ var $7a294d96e9d5a186$var$SubjectSubscriber = function(_super) {
    $7a294d96e9d5a186$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($axeml.Subscriber);
module.exports.SubjectSubscriber = $7a294d96e9d5a186$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $7a294d96e9d5a186$var$Subject = function(_super) {
    $7a294d96e9d5a186$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$1GCxN.rxSubscriber] = function() {
        return new $7a294d96e9d5a186$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $7a294d96e9d5a186$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $bGuMq.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $8v4h5.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $8v4h5.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $lQpfG.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $YgydF.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $7a294d96e9d5a186$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($YgydF.Observable);
module.exports.Subject = $7a294d96e9d5a186$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $7a294d96e9d5a186$var$AnonymousSubject = function(_super) {
    $7a294d96e9d5a186$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $8v4h5.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($7a294d96e9d5a186$var$Subject);
module.exports.AnonymousSubject = $7a294d96e9d5a186$var$AnonymousSubject;

});

parcelRegister("bGuMq", function(module, exports) {
"use strict";
var $881b7e3de85d5304$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $881b7e3de85d5304$var$ObjectUnsubscribedError = function(_super) {
    $881b7e3de85d5304$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $881b7e3de85d5304$var$ObjectUnsubscribedError;

});

parcelRegister("k8JsH", function(module, exports) {
"use strict";
var $ea97d1c620eb909b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4iRIL = parcelRequire("4iRIL");


var $47xz6 = parcelRequire("47xz6");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ea97d1c620eb909b$var$AsyncAction = function(_super) {
    $ea97d1c620eb909b$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $4iRIL.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $4iRIL.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($47xz6.Action);
module.exports.AsyncAction = $ea97d1c620eb909b$var$AsyncAction;

});

parcelRegister("iOeLv", function(module, exports) {
"use strict";
var $db18598c989a1f2a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $d45177949865f933$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $d45177949865f933$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$d45177949865f933$export$d3e54bb8584cda7c = $d45177949865f933$var$Scheduler;


var $db18598c989a1f2a$var$AsyncScheduler = function(_super) {
    $db18598c989a1f2a$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($d45177949865f933$export$d3e54bb8584cda7c);
module.exports.AsyncScheduler = $db18598c989a1f2a$var$AsyncScheduler;

});

parcelRegister("ezhv2", function(module, exports) {
const $370aed914e913934$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });



var $jcSqS = parcelRequire("jcSqS");

const $9065371599574dde$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $370aed914e913934$export$a1c3205f28a20414)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $jcSqS.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};
module.exports["getDimensionsFromBlob"] = $9065371599574dde$export$71797c284d89a3e1;

});

parcelRegister("kSxxi", function(module, exports) {

var $JXmwv = parcelRequire("JXmwv");

var $6rtaQ = parcelRequire("6rtaQ");


var $jcSqS = parcelRequire("jcSqS");

async function $5c0257e5b9d7a2d7$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $JXmwv.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $6rtaQ.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $jcSqS.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}
module.exports["shouldFetchRemoteFileStates"] = $5c0257e5b9d7a2d7$export$2ccdd6f9a9eba6a;

});

parcelRegister("5h2n5", function(module, exports) {

var $2WUwQ = parcelRequire("2WUwQ");

const $b220058cfc7007f2$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $b220058cfc7007f2$export$4c54d536f8e37dc2 {
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $2WUwQ.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $2WUwQ.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
    constructor(options){
        this.options = void 0;
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.onError = void 0;
        this.timeoutId = 0;
        this.options = {
            ...$b220058cfc7007f2$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
}
module.exports["PollingFunction"] = $b220058cfc7007f2$export$4c54d536f8e37dc2;

});

parcelRegister("ld7ZZ", function(module, exports) {
const $8225bb46b3d050bb$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $8225bb46b3d050bb$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $8225bb46b3d050bb$export$d32fc52697b2ec92) return true;
    }
    return false;
}
module.exports["isEmptyFile"] = $8225bb46b3d050bb$export$728192ce8dd94659;

});

parcelRegister("9EPd0", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => (parcelRequire("eUfuX")).mediaStore);

var $eUfuX = parcelRequire("eUfuX");


});

parcelRegister("foB1g", function(module, exports) {
// src/utils/env.ts
var $b355d02d271b0918$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $b355d02d271b0918$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $b355d02d271b0918$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $b355d02d271b0918$var$errors = [];
function $b355d02d271b0918$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $b355d02d271b0918$var$O = Object;
var $b355d02d271b0918$var$getPrototypeOf = $b355d02d271b0918$var$O.getPrototypeOf;
var $b355d02d271b0918$var$CONSTRUCTOR = "constructor";
var $b355d02d271b0918$var$PROTOTYPE = "prototype";
var $b355d02d271b0918$var$CONFIGURABLE = "configurable";
var $b355d02d271b0918$var$ENUMERABLE = "enumerable";
var $b355d02d271b0918$var$WRITABLE = "writable";
var $b355d02d271b0918$var$VALUE = "value";
var $b355d02d271b0918$export$541ac630993a4c84 = (value)=>!!value && !!value[$b355d02d271b0918$var$DRAFT_STATE];
function $b355d02d271b0918$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $b355d02d271b0918$var$isPlainObject(value) || $b355d02d271b0918$var$isArray(value) || !!value[$b355d02d271b0918$export$6ee2082928bcb0ee] || !!value[$b355d02d271b0918$var$CONSTRUCTOR]?.[$b355d02d271b0918$export$6ee2082928bcb0ee] || $b355d02d271b0918$var$isMap(value) || $b355d02d271b0918$var$isSet(value);
}
var $b355d02d271b0918$var$objectCtorString = $b355d02d271b0918$var$O[$b355d02d271b0918$var$PROTOTYPE][$b355d02d271b0918$var$CONSTRUCTOR].toString();
var $b355d02d271b0918$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $b355d02d271b0918$var$isPlainObject(value) {
    if (!value || !$b355d02d271b0918$var$isObjectish(value)) return false;
    const proto = $b355d02d271b0918$var$getPrototypeOf(value);
    if (proto === null || proto === $b355d02d271b0918$var$O[$b355d02d271b0918$var$PROTOTYPE]) return true;
    const Ctor = $b355d02d271b0918$var$O.hasOwnProperty.call(proto, $b355d02d271b0918$var$CONSTRUCTOR) && proto[$b355d02d271b0918$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$b355d02d271b0918$var$isFunction(Ctor)) return false;
    let ctorString = $b355d02d271b0918$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $b355d02d271b0918$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $b355d02d271b0918$var$objectCtorString;
}
function $b355d02d271b0918$export$22e8af3f75a010e3(value) {
    if (!$b355d02d271b0918$export$541ac630993a4c84(value)) $b355d02d271b0918$var$die(15, value);
    return value[$b355d02d271b0918$var$DRAFT_STATE].base_;
}
function $b355d02d271b0918$var$each(obj, iter, strict = true) {
    if ($b355d02d271b0918$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $b355d02d271b0918$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $b355d02d271b0918$var$getArchtype(thing) {
    const state = thing[$b355d02d271b0918$var$DRAFT_STATE];
    return state ? state.type_ : $b355d02d271b0918$var$isArray(thing) ? 1 /* Array */  : $b355d02d271b0918$var$isMap(thing) ? 2 /* Map */  : $b355d02d271b0918$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $b355d02d271b0918$var$has = (thing, prop, type = $b355d02d271b0918$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $b355d02d271b0918$var$O[$b355d02d271b0918$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $b355d02d271b0918$var$get = (thing, prop, type = $b355d02d271b0918$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $b355d02d271b0918$var$set = (thing, propOrOldValue, value, type = $b355d02d271b0918$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $b355d02d271b0918$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $b355d02d271b0918$var$isArray = Array.isArray;
var $b355d02d271b0918$var$isMap = (target)=>target instanceof Map;
var $b355d02d271b0918$var$isSet = (target)=>target instanceof Set;
var $b355d02d271b0918$var$isObjectish = (target)=>typeof target === "object";
var $b355d02d271b0918$var$isFunction = (target)=>typeof target === "function";
var $b355d02d271b0918$var$isBoolean = (target)=>typeof target === "boolean";
function $b355d02d271b0918$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $b355d02d271b0918$var$getProxyDraft = (value)=>{
    if (!$b355d02d271b0918$var$isObjectish(value)) return null;
    return value?.[$b355d02d271b0918$var$DRAFT_STATE];
};
var $b355d02d271b0918$var$latest = (state)=>state.copy_ || state.base_;
var $b355d02d271b0918$var$getValue = (value)=>{
    const proxyDraft = $b355d02d271b0918$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $b355d02d271b0918$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $b355d02d271b0918$var$shallowCopy(base, strict) {
    if ($b355d02d271b0918$var$isMap(base)) return new Map(base);
    if ($b355d02d271b0918$var$isSet(base)) return new Set(base);
    if ($b355d02d271b0918$var$isArray(base)) return Array[$b355d02d271b0918$var$PROTOTYPE].slice.call(base);
    const isPlain = $b355d02d271b0918$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $b355d02d271b0918$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$b355d02d271b0918$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$b355d02d271b0918$var$WRITABLE] === false) {
                desc[$b355d02d271b0918$var$WRITABLE] = true;
                desc[$b355d02d271b0918$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$b355d02d271b0918$var$CONFIGURABLE]: true,
                [$b355d02d271b0918$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$b355d02d271b0918$var$ENUMERABLE]: desc[$b355d02d271b0918$var$ENUMERABLE],
                [$b355d02d271b0918$var$VALUE]: base[key]
            };
        }
        return $b355d02d271b0918$var$O.create($b355d02d271b0918$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $b355d02d271b0918$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $b355d02d271b0918$var$O.create(proto);
        return $b355d02d271b0918$var$O.assign(obj, base);
    }
}
function $b355d02d271b0918$export$792f3d81ea979f55(obj, deep = false) {
    if ($b355d02d271b0918$var$isFrozen(obj) || $b355d02d271b0918$export$541ac630993a4c84(obj) || !$b355d02d271b0918$export$16e3aed3edb85946(obj)) return obj;
    if ($b355d02d271b0918$var$getArchtype(obj) > 1) $b355d02d271b0918$var$O.defineProperties(obj, {
        set: $b355d02d271b0918$var$dontMutateMethodOverride,
        add: $b355d02d271b0918$var$dontMutateMethodOverride,
        clear: $b355d02d271b0918$var$dontMutateMethodOverride,
        delete: $b355d02d271b0918$var$dontMutateMethodOverride
    });
    $b355d02d271b0918$var$O.freeze(obj);
    if (deep) $b355d02d271b0918$var$each(obj, (_key, value)=>{
        $b355d02d271b0918$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $b355d02d271b0918$var$dontMutateFrozenCollections() {
    $b355d02d271b0918$var$die(2);
}
var $b355d02d271b0918$var$dontMutateMethodOverride = {
    [$b355d02d271b0918$var$VALUE]: $b355d02d271b0918$var$dontMutateFrozenCollections
};
function $b355d02d271b0918$var$isFrozen(obj) {
    if (obj === null || !$b355d02d271b0918$var$isObjectish(obj)) return true;
    return $b355d02d271b0918$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $b355d02d271b0918$var$PluginMapSet = "MapSet";
var $b355d02d271b0918$var$PluginPatches = "Patches";
var $b355d02d271b0918$var$PluginArrayMethods = "ArrayMethods";
var $b355d02d271b0918$var$plugins = {};
function $b355d02d271b0918$var$getPlugin(pluginKey) {
    const plugin = $b355d02d271b0918$var$plugins[pluginKey];
    if (!plugin) $b355d02d271b0918$var$die(0, pluginKey);
    return plugin;
}
var $b355d02d271b0918$var$isPluginLoaded = (pluginKey)=>!!$b355d02d271b0918$var$plugins[pluginKey];
function $b355d02d271b0918$var$loadPlugin(pluginKey, implementation) {
    if (!$b355d02d271b0918$var$plugins[pluginKey]) $b355d02d271b0918$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $b355d02d271b0918$var$currentScope;
var $b355d02d271b0918$var$getCurrentScope = ()=>$b355d02d271b0918$var$currentScope;
var $b355d02d271b0918$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $b355d02d271b0918$var$isPluginLoaded($b355d02d271b0918$var$PluginMapSet) ? $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $b355d02d271b0918$var$isPluginLoaded($b355d02d271b0918$var$PluginArrayMethods) ? $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginArrayMethods) : void 0
    });
function $b355d02d271b0918$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $b355d02d271b0918$var$revokeScope(scope) {
    $b355d02d271b0918$var$leaveScope(scope);
    scope.drafts_.forEach($b355d02d271b0918$var$revokeDraft);
    scope.drafts_ = null;
}
function $b355d02d271b0918$var$leaveScope(scope) {
    if (scope === $b355d02d271b0918$var$currentScope) $b355d02d271b0918$var$currentScope = scope.parent_;
}
var $b355d02d271b0918$var$enterScope = (immer2)=>$b355d02d271b0918$var$currentScope = $b355d02d271b0918$var$createScope($b355d02d271b0918$var$currentScope, immer2);
function $b355d02d271b0918$var$revokeDraft(draft) {
    const state = draft[$b355d02d271b0918$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $b355d02d271b0918$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$b355d02d271b0918$var$DRAFT_STATE].modified_) {
            $b355d02d271b0918$var$revokeScope(scope);
            $b355d02d271b0918$var$die(4);
        }
        if ($b355d02d271b0918$export$16e3aed3edb85946(result)) result = $b355d02d271b0918$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$b355d02d271b0918$var$DRAFT_STATE].base_, result, scope);
    } else result = $b355d02d271b0918$var$finalize(scope, baseDraft);
    $b355d02d271b0918$var$maybeFreeze(scope, result, true);
    $b355d02d271b0918$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $b355d02d271b0918$export$45b790e32b2810ee ? result : void 0;
}
function $b355d02d271b0918$var$finalize(rootScope, value) {
    if ($b355d02d271b0918$var$isFrozen(value)) return value;
    const state = value[$b355d02d271b0918$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $b355d02d271b0918$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$b355d02d271b0918$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $b355d02d271b0918$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $b355d02d271b0918$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $b355d02d271b0918$export$792f3d81ea979f55(value, deep);
}
function $b355d02d271b0918$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $b355d02d271b0918$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $b355d02d271b0918$var$EMPTY_LOCATIONS_RESULT = [];
function $b355d02d271b0918$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $b355d02d271b0918$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $b355d02d271b0918$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $b355d02d271b0918$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $b355d02d271b0918$var$each(parentCopy, (key, value)=>{
            if ($b355d02d271b0918$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $b355d02d271b0918$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$b355d02d271b0918$var$set(parentCopy, location, finalizedValue, parentType);
}
function $b355d02d271b0918$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$b355d02d271b0918$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $b355d02d271b0918$var$getFinalValue(state);
        $b355d02d271b0918$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $b355d02d271b0918$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $b355d02d271b0918$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $b355d02d271b0918$var$markStateFinalized(state);
    }
}
function $b355d02d271b0918$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($b355d02d271b0918$export$541ac630993a4c84(value)) {
        const state = value[$b355d02d271b0918$var$DRAFT_STATE];
        if ($b355d02d271b0918$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $b355d02d271b0918$var$prepareCopy(target);
            const finalizedValue = $b355d02d271b0918$var$getFinalValue(state);
            $b355d02d271b0918$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($b355d02d271b0918$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $b355d02d271b0918$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $b355d02d271b0918$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($b355d02d271b0918$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $b355d02d271b0918$var$handleValue($b355d02d271b0918$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $b355d02d271b0918$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($b355d02d271b0918$export$541ac630993a4c84(target) || handledSet.has(target) || !$b355d02d271b0918$export$16e3aed3edb85946(target) || $b355d02d271b0918$var$isFrozen(target)) return target;
    handledSet.add(target);
    $b355d02d271b0918$var$each(target, (key, value)=>{
        if ($b355d02d271b0918$export$541ac630993a4c84(value)) {
            const state = value[$b355d02d271b0918$var$DRAFT_STATE];
            if ($b355d02d271b0918$var$isSameScope(state, rootScope)) {
                const updatedValue = $b355d02d271b0918$var$getFinalValue(state);
                $b355d02d271b0918$var$set(target, key, updatedValue, target.type_);
                $b355d02d271b0918$var$markStateFinalized(state);
            }
        } else if ($b355d02d271b0918$export$16e3aed3edb85946(value)) $b355d02d271b0918$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $b355d02d271b0918$var$createProxyProxy(base, parent) {
    const baseIsArray = $b355d02d271b0918$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $b355d02d271b0918$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $b355d02d271b0918$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $b355d02d271b0918$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $b355d02d271b0918$var$objectTraps = {
    get (state, prop) {
        if (prop === $b355d02d271b0918$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $b355d02d271b0918$var$latest(state);
        if (!$b355d02d271b0918$var$has(source, prop, state.type_)) return $b355d02d271b0918$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$b355d02d271b0918$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $b355d02d271b0918$var$isArrayIndex(prop)) return value;
        if (value === $b355d02d271b0918$var$peek(state.base_, prop)) {
            $b355d02d271b0918$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $b355d02d271b0918$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $b355d02d271b0918$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($b355d02d271b0918$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $b355d02d271b0918$var$getDescriptorFromProto($b355d02d271b0918$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $b355d02d271b0918$var$peek($b355d02d271b0918$var$latest(state), prop);
            const currentState = current2?.[$b355d02d271b0918$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($b355d02d271b0918$var$is(value, current2) && (value !== void 0 || $b355d02d271b0918$var$has(state.base_, prop, state.type_))) return true;
            $b355d02d271b0918$var$prepareCopy(state);
            $b355d02d271b0918$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $b355d02d271b0918$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $b355d02d271b0918$var$prepareCopy(state);
        if ($b355d02d271b0918$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $b355d02d271b0918$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $b355d02d271b0918$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$b355d02d271b0918$var$WRITABLE]: true,
            [$b355d02d271b0918$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$b355d02d271b0918$var$ENUMERABLE]: desc[$b355d02d271b0918$var$ENUMERABLE],
            [$b355d02d271b0918$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $b355d02d271b0918$var$die(11);
    },
    getPrototypeOf (state) {
        return $b355d02d271b0918$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $b355d02d271b0918$var$die(12);
    }
};
var $b355d02d271b0918$var$arrayTraps = {};
for(let key in $b355d02d271b0918$var$objectTraps){
    let fn = $b355d02d271b0918$var$objectTraps[key];
    $b355d02d271b0918$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$b355d02d271b0918$var$arrayTraps.deleteProperty = function(state, prop) {
    return $b355d02d271b0918$var$arrayTraps.set.call(this, state, prop, void 0);
};
$b355d02d271b0918$var$arrayTraps.set = function(state, prop, value) {
    return $b355d02d271b0918$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $b355d02d271b0918$var$peek(draft, prop) {
    const state = draft[$b355d02d271b0918$var$DRAFT_STATE];
    const source = state ? $b355d02d271b0918$var$latest(state) : draft;
    return source[prop];
}
function $b355d02d271b0918$var$readPropFromProto(state, source, prop) {
    const desc = $b355d02d271b0918$var$getDescriptorFromProto(source, prop);
    return desc ? $b355d02d271b0918$var$VALUE in desc ? desc[$b355d02d271b0918$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $b355d02d271b0918$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $b355d02d271b0918$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $b355d02d271b0918$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $b355d02d271b0918$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $b355d02d271b0918$var$markChanged(state.parent_);
    }
}
function $b355d02d271b0918$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $b355d02d271b0918$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $b355d02d271b0918$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$b355d02d271b0918$export$16e3aed3edb85946(base)) $b355d02d271b0918$var$die(8);
        if ($b355d02d271b0918$export$541ac630993a4c84(base)) base = $b355d02d271b0918$export$97aac956da55dae9(base);
        const scope = $b355d02d271b0918$var$enterScope(this);
        const proxy = $b355d02d271b0918$var$createProxy(scope, base, void 0);
        proxy[$b355d02d271b0918$var$DRAFT_STATE].isManual_ = true;
        $b355d02d271b0918$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$b355d02d271b0918$var$DRAFT_STATE];
        if (!state || !state.isManual_) $b355d02d271b0918$var$die(9);
        const { scope_: scope } = state;
        $b355d02d271b0918$var$usePatchesInScope(scope, patchListener);
        return $b355d02d271b0918$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginPatches).applyPatches_;
        if ($b355d02d271b0918$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($b355d02d271b0918$var$isFunction(base) && !$b355d02d271b0918$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$b355d02d271b0918$var$isFunction(recipe)) $b355d02d271b0918$var$die(6);
            if (patchListener !== void 0 && !$b355d02d271b0918$var$isFunction(patchListener)) $b355d02d271b0918$var$die(7);
            let result;
            if ($b355d02d271b0918$export$16e3aed3edb85946(base)) {
                const scope = $b355d02d271b0918$var$enterScope(this);
                const proxy = $b355d02d271b0918$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $b355d02d271b0918$var$revokeScope(scope);
                    else $b355d02d271b0918$var$leaveScope(scope);
                }
                $b355d02d271b0918$var$usePatchesInScope(scope, patchListener);
                return $b355d02d271b0918$var$processResult(result, scope);
            } else if (!base || !$b355d02d271b0918$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $b355d02d271b0918$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $b355d02d271b0918$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $b355d02d271b0918$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($b355d02d271b0918$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($b355d02d271b0918$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($b355d02d271b0918$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($b355d02d271b0918$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
};
function $b355d02d271b0918$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $b355d02d271b0918$var$isMap(value) ? $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginMapSet).proxyMap_(value, parent) : $b355d02d271b0918$var$isSet(value) ? $b355d02d271b0918$var$getPlugin($b355d02d271b0918$var$PluginMapSet).proxySet_(value, parent) : $b355d02d271b0918$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $b355d02d271b0918$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $b355d02d271b0918$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $b355d02d271b0918$export$97aac956da55dae9(value) {
    if (!$b355d02d271b0918$export$541ac630993a4c84(value)) $b355d02d271b0918$var$die(10, value);
    return $b355d02d271b0918$var$currentImpl(value);
}
function $b355d02d271b0918$var$currentImpl(value) {
    if (!$b355d02d271b0918$export$16e3aed3edb85946(value) || $b355d02d271b0918$var$isFrozen(value)) return value;
    const state = value[$b355d02d271b0918$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $b355d02d271b0918$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $b355d02d271b0918$var$shallowCopy(value, true);
    $b355d02d271b0918$var$each(copy, (key, childValue)=>{
        $b355d02d271b0918$var$set(copy, key, $b355d02d271b0918$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $b355d02d271b0918$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $b355d02d271b0918$var$getProxyDraft($b355d02d271b0918$var$get(parentCopy, state.key_));
            const valueAtKey = $b355d02d271b0918$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $b355d02d271b0918$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $b355d02d271b0918$var$get(current2, key);
            if (!$b355d02d271b0918$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$b355d02d271b0918$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $b355d02d271b0918$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $b355d02d271b0918$var$get(base_, key, type_);
            const value = $b355d02d271b0918$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $b355d02d271b0918$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $b355d02d271b0918$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $b355d02d271b0918$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $b355d02d271b0918$var$CONSTRUCTOR)) $b355d02d271b0918$var$die(errorOffset + 3);
                if ($b355d02d271b0918$var$isFunction(base) && p === $b355d02d271b0918$var$PROTOTYPE) $b355d02d271b0918$var$die(errorOffset + 3);
                base = $b355d02d271b0918$var$get(base, p);
                if (!$b355d02d271b0918$var$isObjectish(base)) $b355d02d271b0918$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $b355d02d271b0918$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $b355d02d271b0918$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $b355d02d271b0918$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$b355d02d271b0918$export$16e3aed3edb85946(obj)) return obj;
        if ($b355d02d271b0918$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($b355d02d271b0918$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($b355d02d271b0918$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($b355d02d271b0918$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($b355d02d271b0918$var$has(obj, $b355d02d271b0918$export$6ee2082928bcb0ee)) cloned[$b355d02d271b0918$export$6ee2082928bcb0ee] = obj[$b355d02d271b0918$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($b355d02d271b0918$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $b355d02d271b0918$var$loadPlugin($b355d02d271b0918$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $b355d02d271b0918$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $b355d02d271b0918$var$latest(this[$b355d02d271b0918$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $b355d02d271b0918$var$latest(this[$b355d02d271b0918$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$b355d02d271b0918$var$latest(state).has(key) || $b355d02d271b0918$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $b355d02d271b0918$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $b355d02d271b0918$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $b355d02d271b0918$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b355d02d271b0918$var$latest(state).size) {
                prepareMapCopy(state);
                $b355d02d271b0918$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $b355d02d271b0918$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            $b355d02d271b0918$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $b355d02d271b0918$var$latest(state).get(key);
            if (state.finalized_ || !$b355d02d271b0918$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $b355d02d271b0918$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $b355d02d271b0918$var$latest(this[$b355d02d271b0918$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($b355d02d271b0918$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$b355d02d271b0918$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b355d02d271b0918$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$b355d02d271b0918$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $b355d02d271b0918$var$latest(this[$b355d02d271b0918$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $b355d02d271b0918$var$markChanged(state);
                state.copy_.add(value);
                $b355d02d271b0918$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $b355d02d271b0918$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b355d02d271b0918$var$latest(state).size) {
                prepareSetCopy(state);
                $b355d02d271b0918$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$b355d02d271b0918$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($b355d02d271b0918$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$b355d02d271b0918$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b355d02d271b0918$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$b355d02d271b0918$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($b355d02d271b0918$export$16e3aed3edb85946(value)) {
                    const draft = $b355d02d271b0918$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $b355d02d271b0918$var$die(3, JSON.stringify($b355d02d271b0918$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($b355d02d271b0918$var$getValue(value));
            });
        }
    }
    $b355d02d271b0918$var$loadPlugin($b355d02d271b0918$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $b355d02d271b0918$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $b355d02d271b0918$var$prepareCopy(state);
        const result = operation();
        $b355d02d271b0918$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $b355d02d271b0918$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $b355d02d271b0918$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $b355d02d271b0918$var$loadPlugin($b355d02d271b0918$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $b355d02d271b0918$var$immer = new $b355d02d271b0918$export$aaadc6ff0f822719();
var $b355d02d271b0918$export$b46cabe22e78bc00 = $b355d02d271b0918$var$immer.produce;
var $b355d02d271b0918$export$4da66d41c9492c78 = /* @__PURE__ */ $b355d02d271b0918$var$immer.produceWithPatches.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$573f26f60825c493 = /* @__PURE__ */ $b355d02d271b0918$var$immer.setAutoFreeze.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$333ce65961cbe047 = /* @__PURE__ */ $b355d02d271b0918$var$immer.setUseStrictShallowCopy.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$1045b3be3904c489 = /* @__PURE__ */ $b355d02d271b0918$var$immer.setUseStrictIteration.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $b355d02d271b0918$var$immer.applyPatches.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$3c3214997190395f = /* @__PURE__ */ $b355d02d271b0918$var$immer.createDraft.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$c60f5e69c521b528 = /* @__PURE__ */ $b355d02d271b0918$var$immer.finishDraft.bind($b355d02d271b0918$var$immer);
var $b355d02d271b0918$export$c05b21e3257751e5 = (value)=>value;
var $b355d02d271b0918$export$20f911b3f8cf0b74 = (value)=>value;
module.exports["produce"] = $b355d02d271b0918$export$b46cabe22e78bc00;

});

parcelRegister("9mu1x", function(module, exports) {
var $6d0d753e2a843bd0$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/vanilla.mjs"
});
const $6d0d753e2a843bd0$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($6d0d753e2a843bd0$import_meta.env ? $6d0d753e2a843bd0$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $6d0d753e2a843bd0$export$f51a9068ac82ea43 = (createState)=>createState ? $6d0d753e2a843bd0$var$createStoreImpl(createState) : $6d0d753e2a843bd0$var$createStoreImpl;
var $6d0d753e2a843bd0$export$2e2bcd8739ae039 = (createState)=>{
    if (($6d0d753e2a843bd0$import_meta.env ? $6d0d753e2a843bd0$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $6d0d753e2a843bd0$export$f51a9068ac82ea43(createState);
};
module.exports["createStore"] = $6d0d753e2a843bd0$export$f51a9068ac82ea43;

});

parcelRegister("1kgKO", function(module, exports) {

let $0f74a7ba6f591e8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f74a7ba6f591e8b$var$load("haemK").then(()=>parcelRequire('kVKIu'));

});

parcelRegister("khxnJ", function(module, exports) {
const $2d8144871e2f1b1a$var$maxEmojiSizeInBytes = 1048576;
const $2d8144871e2f1b1a$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $2d8144871e2f1b1a$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $2d8144871e2f1b1a$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $2d8144871e2f1b1a$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $2d8144871e2f1b1a$var$isWebpSupported;
const $2d8144871e2f1b1a$export$c5a964eb84c7fca8 = ()=>{
    if ($2d8144871e2f1b1a$var$isWebpSupported !== undefined) return Promise.resolve($2d8144871e2f1b1a$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $2d8144871e2f1b1a$var$isWebpSupported = img.height === 2;
            resolve($2d8144871e2f1b1a$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $2d8144871e2f1b1a$export$f8e7886bc155c2e6 = ()=>$2d8144871e2f1b1a$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });
module.exports["getNaturalImageSize"] = $2d8144871e2f1b1a$export$90153ab95f408dfa;
module.exports["parseImage"] = $2d8144871e2f1b1a$export$37bbb051492a18a7;
module.exports["hasFileExceededSize"] = $2d8144871e2f1b1a$export$a115ddd5941792f1;
module.exports["imageAcceptHeader"] = $2d8144871e2f1b1a$export$f8e7886bc155c2e6;

});

parcelRegister("7ZWaV", function(module, exports) {

var $aGYoD = parcelRequire("aGYoD");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $4SCyD = parcelRequire("4SCyD");


var $cGMbZ = parcelRequire("cGMbZ");

const $294db541fd062d85$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $294db541fd062d85$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $iqaft.ExperienceTypes).Experience,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
    };
};
const $294db541fd062d85$var$customEmojiTimings = [
    {
        key: (0, $aGYoD.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $aGYoD.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $aGYoD.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $aGYoD.UfoEmojiTimings).METADATA_START,
        endMark: (0, $aGYoD.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $aGYoD.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $aGYoD.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $aGYoD.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $aGYoD.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $aGYoD.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $aGYoD.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $aGYoD.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $aGYoD.UfoEmojiTimings).ONLOAD_END
    }
];
const $294db541fd062d85$export$615f888019c45765 = {
    'emoji-rendered': new (0, $9801n.ConcurrentExperience)((0, $aGYoD.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $aGYoD.UfoComponentName).EMOJI
        },
        type: (0, $iqaft.ExperienceTypes).Operation,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).Custom,
        timings: $294db541fd062d85$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $9801n.ConcurrentExperience)((0, $aGYoD.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $294db541fd062d85$var$createRenderExperience((0, $aGYoD.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $4SCyD.UFOExperience)((0, $aGYoD.UfoExperienceName).EMOJI_PICKER_OPENED, $294db541fd062d85$var$createRenderExperience((0, $aGYoD.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $4SCyD.UFOExperience)((0, $aGYoD.UfoExperienceName).EMOJI_SELECTION_RECORDED, $294db541fd062d85$var$createInlineExperience((0, $aGYoD.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $4SCyD.UFOExperience)((0, $aGYoD.UfoExperienceName).EMOJI_UPLOADED, $294db541fd062d85$var$createInlineExperience((0, $aGYoD.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $4SCyD.UFOExperience)((0, $aGYoD.UfoExperienceName).EMOJI_SEARCHED, $294db541fd062d85$var$createInlineExperience((0, $aGYoD.UfoComponentName).EMOJI_PICKER))
};
const $294db541fd062d85$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $cGMbZ.withSampling)($294db541fd062d85$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $294db541fd062d85$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $294db541fd062d85$export$1466212a1606133 = (providerType)=>{
    return (0, $cGMbZ.withSampling)($294db541fd062d85$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};
module.exports["ufoExperiences"] = $294db541fd062d85$export$615f888019c45765;
module.exports["sampledUfoRenderedEmoji"] = $294db541fd062d85$export$71c8cba6f1251ea9;
module.exports["hasUfoMarked"] = $294db541fd062d85$export$a9be054d2a5cedc0;
module.exports["sampledUfoEmojiResourceFetched"] = $294db541fd062d85$export$1466212a1606133;

});

parcelRegister("9801n", function(module, exports) {

var $fJPgb = parcelRequire("fJPgb");


var $4SCyD = parcelRequire("4SCyD");

class $43520f7cc17d07ab$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $4SCyD.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $fJPgb.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $43520f7cc17d07ab$export$ac1cddfee07ba6ac;

});

parcelRegister("fJPgb", function(module, exports) {
class $5c903d0a575d5e77$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($5c903d0a575d5e77$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($5c903d0a575d5e77$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$5c903d0a575d5e77$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $5c903d0a575d5e77$export$4ab84f6f04f6566d = new $5c903d0a575d5e77$var$UFOLogger();
const $5c903d0a575d5e77$export$b4958caff08a0960 = (...args)=>{
    $5c903d0a575d5e77$export$4ab84f6f04f6566d.log(...args);
};
const $5c903d0a575d5e77$export$d53d07b6034c4560 = (...args)=>{
    $5c903d0a575d5e77$export$4ab84f6f04f6566d.warn(...args);
};
module.exports["ufolog"] = $5c903d0a575d5e77$export$b4958caff08a0960;
module.exports["ufowarn"] = $5c903d0a575d5e77$export$d53d07b6034c4560;

});

parcelRegister("4SCyD", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $dQl1W = parcelRequire("dQl1W");

// temp solution until we can get it automated
const $6f20e4ee3a62c17f$export$2295b861f318254a = '0.1.5';



var $fJPgb = parcelRequire("fJPgb");

var $b4d260c0044bdf63$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $b4d260c0044bdf63$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $b4d260c0044bdf63$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $b4d260c0044bdf63$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $b4d260c0044bdf63$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $b4d260c0044bdf63$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $b4d260c0044bdf63$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $b4d260c0044bdf63$export$9f2bf58999404c75 = 'fmp';
const $b4d260c0044bdf63$export$837e0f79a8056912 = 'inline-response';


const $18d431c2809159e2$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $18d431c2809159e2$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $18d431c2809159e2$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $18d431c2809159e2$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $fJPgb.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $18d431c2809159e2$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $b4d260c0044bdf63$export$96253c35c37cf96b).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $18d431c2809159e2$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $b4d260c0044bdf63$export$96253c35c37cf96b).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $18d431c2809159e2$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $b4d260c0044bdf63$export$96253c35c37cf96b).EXPERIENCE_PAYLOAD,
        payload: data
    };
};





const $b303d799e3862de8$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};


class $4abcfef71ff7e2c9$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $b303d799e3862de8$export$15e172712955e18f)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $4abcfef71ff7e2c9$export$13e680397ec8f3eb = new $4abcfef71ff7e2c9$var$VisibilityChangeObserver();



const $2db7b4656bf44a13$export$5f490af6b2b115cf = ()=>~~performance.now();




var $28cxD = parcelRequire("28cxD");




const $7ac3fc75b1a6e81b$var$UFOStateAvailableTransitions = {
    [(0, $28cxD.UFOExperienceState).NOT_STARTED.id]: [
        (0, $28cxD.UFOExperienceState).STARTED.id
    ],
    [(0, $28cxD.UFOExperienceState).STARTED.id]: [
        (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
        (0, $28cxD.UFOExperienceState).BLOCKED.id,
        (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
        (0, $28cxD.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $28cxD.UFOExperienceState).FAILED.id,
        (0, $28cxD.UFOExperienceState).ABORTED.id
    ],
    [(0, $28cxD.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $28cxD.UFOExperienceState).BLOCKED.id,
        (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
        (0, $28cxD.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $28cxD.UFOExperienceState).FAILED.id,
        (0, $28cxD.UFOExperienceState).ABORTED.id
    ],
    [(0, $28cxD.UFOExperienceState).BLOCKED.id]: [
        (0, $28cxD.UFOExperienceState).RECOVERED.id,
        (0, $28cxD.UFOExperienceState).ABORTED.id
    ],
    [(0, $28cxD.UFOExperienceState).RECOVERED.id]: [
        (0, $28cxD.UFOExperienceState).STARTED.id,
        (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
        (0, $28cxD.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $28cxD.UFOExperienceState).FAILED.id,
        (0, $28cxD.UFOExperienceState).ABORTED.id
    ],
    [(0, $28cxD.UFOExperienceState).SUCCEEDED.id]: [
        (0, $28cxD.UFOExperienceState).STARTED.id
    ],
    [(0, $28cxD.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
        (0, $28cxD.UFOExperienceState).FAILED.id,
        (0, $28cxD.UFOExperienceState).ABORTED.id
    ],
    [(0, $28cxD.UFOExperienceState).FAILED.id]: [
        (0, $28cxD.UFOExperienceState).STARTED.id
    ],
    [(0, $28cxD.UFOExperienceState).ABORTED.id]: [
        (0, $28cxD.UFOExperienceState).STARTED.id
    ]
};
const $7ac3fc75b1a6e81b$export$178881f329fdb81f = (state1, state2)=>{
    return $7ac3fc75b1a6e81b$var$UFOStateAvailableTransitions[state1.id] && $7ac3fc75b1a6e81b$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};



var $iqaft = parcelRequire("iqaft");

const $779917bcbfffdfdf$var$getPageVisibleState = ()=>{
    return !(0, $b303d799e3862de8$export$15e172712955e18f)() || !window.document || window.document.visibilityState === 'visible' ? (0, $b4d260c0044bdf63$export$a12c67b37a306b13).VISIBLE : (0, $b4d260c0044bdf63$export$a12c67b37a306b13).HIDDEN;
};
const $779917bcbfffdfdf$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2db7b4656bf44a13$export$5f490af6b2b115cf)();
};
class $779917bcbfffdfdf$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $fJPgb.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $7ac3fc75b1a6e81b$export$178881f329fdb81f)(this.state, newState)) {
            (0, $fJPgb.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $28cxD.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $779917bcbfffdfdf$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $dQl1W.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $779917bcbfffdfdf$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $18d431c2809159e2$export$6123a44dc2384540)().push((0, $18d431c2809159e2$export$ee1a7bd1fc9ea85e)((0, $b4d260c0044bdf63$export$79bf131685ad41d7), this.handleDoneBind));
                const data = await this.exportData();
                (0, $fJPgb.ufolog)('this.parent', this.parent);
                (0, $18d431c2809159e2$export$6123a44dc2384540)().push((0, $18d431c2809159e2$export$7c957416596ca127)(data));
            }
            return true;
        }
        (0, $fJPgb.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $fJPgb.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $28cxD.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $779917bcbfffdfdf$var$getPageVisibleState();
            (0, $4abcfef71ff7e2c9$export$13e680397ec8f3eb).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $fJPgb.ufolog)('subscribed', this.id);
                (0, $18d431c2809159e2$export$6123a44dc2384540)().push((0, $18d431c2809159e2$export$37863216db4b714d)((0, $b4d260c0044bdf63$export$79bf131685ad41d7), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $b4d260c0044bdf63$export$9f2bf58999404c75) && name !== (0, $b4d260c0044bdf63$export$837e0f79a8056912)) this._mark(name, timestamp);
        else (0, $fJPgb.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $779917bcbfffdfdf$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $28cxD.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $b4d260c0044bdf63$export$9f2bf58999404c75), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $b4d260c0044bdf63$export$837e0f79a8056912), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $fJPgb.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $4abcfef71ff7e2c9$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $28cxD.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $28cxD.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $28cxD.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $fJPgb.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $6f20e4ee3a62c17f$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $28cxD.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $b4d260c0044bdf63$export$a12c67b37a306b13).MIXED;
            (0, $4abcfef71ff7e2c9$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $779917bcbfffdfdf$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $iqaft.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}


class $c2ced689a797803a$export$c00d22927c60484a extends (0, $779917bcbfffdfdf$export$d31c89db257648c) {
}
module.exports["UFOExperience"] = $c2ced689a797803a$export$c00d22927c60484a;

});

parcelRegister("28cxD", function(module, exports) {
const $78f03fc0c180b664$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $78f03fc0c180b664$export$81b70111112841a0;

});

parcelRegister("iqaft", function(module, exports) {
var $53df7d6daf991bbd$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $53df7d6daf991bbd$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $53df7d6daf991bbd$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $53df7d6daf991bbd$export$cc26007c03242fff;

});

parcelRegister("cGMbZ", function(module, exports) {
const $48a18efeb1c3ead4$export$c7c4959fece2f3ec = {};
const $48a18efeb1c3ead4$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($48a18efeb1c3ead4$export$c7c4959fece2f3ec))delete $48a18efeb1c3ead4$export$c7c4959fece2f3ec[prop];
};
const $48a18efeb1c3ead4$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $48a18efeb1c3ead4$var$hasSampledFromStart = (experience)=>{
    if (!$48a18efeb1c3ead4$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $48a18efeb1c3ead4$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $48a18efeb1c3ead4$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $48a18efeb1c3ead4$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$48a18efeb1c3ead4$export$c7c4959fece2f3ec[ufoExperience.id]) $48a18efeb1c3ead4$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $48a18efeb1c3ead4$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $48a18efeb1c3ead4$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $48a18efeb1c3ead4$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $48a18efeb1c3ead4$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $48a18efeb1c3ead4$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$48a18efeb1c3ead4$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["withSampling"] = $48a18efeb1c3ead4$export$dc2f0946255b3f89;

});

parcelRegister("eMprr", function(module, exports) {
const $0bfc43b53e411407$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};
module.exports["buildCredentials"] = $0bfc43b53e411407$export$2ac26f1ab7eda637;

});

parcelRegister("hzQni", function(module, exports) {
class $5c0e629dc02dea29$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.lastResult = void 0;
        this.listeners = new Set();
    }
}
module.exports["AbstractResource"] = $5c0e629dc02dea29$export$4529f10aed0950d4;

});

parcelRegister("dAAeA", function(module, exports) {

var $majy4 = parcelRequire("majy4");


var $9trs7 = parcelRequire("9trs7");

const $d96621f52d9ba57c$export$8cef61637918b288 = {
    streams: new (0, $9trs7.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $majy4.EventEmitter2)()
};
module.exports["mediaState"] = $d96621f52d9ba57c$export$8cef61637918b288;

});

parcelRegister("9zykx", function(module, exports) {
var $0281df69e57678c6$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});
module.exports["ChunkHashAlgorithm"] = $0281df69e57678c6$export$d3e73a50cc549c2e;

});

parcelRegister("4HHlm", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $57XaE = parcelRequire("57XaE");


var $T9xHm = parcelRequire("T9xHm");


var $942a0 = parcelRequire("942a0");


var $deNRp = parcelRequire("deNRp");

const $628ae409d0ef745d$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $628ae409d0ef745d$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $628ae409d0ef745d$export$3e47d0e609e44278() {
    return (0, $57XaE.isCommercial)() && !(0, $T9xHm.isIsolatedCloud)() && !(0, $942a0.isGCPtenant)() && (0, $dh538.fg)('platform_media_cdn_delivery') && !(0, $deNRp.isPathBasedEnabled)();
}
function $628ae409d0ef745d$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!$628ae409d0ef745d$export$3e47d0e609e44278() || tokenLength > $628ae409d0ef745d$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!(0, $942a0.isGCPtenant)() && (0, $dh538.fg)('platform_media_cdn_delivery') && (0, $dh538.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $628ae409d0ef745d$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}
module.exports["isCDNEnabled"] = $628ae409d0ef745d$export$3e47d0e609e44278;
module.exports["mapToMediaCdnUrl"] = $628ae409d0ef745d$export$fb88a576cf28364d;

});

parcelRegister("4lI5c", function(module, exports) {
parcelRequire("5vzpD");
var $3HtSd = parcelRequire("3HtSd");


var $fCrf0 = parcelRequire("fCrf0");


var $9Bvtr = parcelRequire("9Bvtr");


var $2ASLw = parcelRequire("2ASLw");

const $a17a7c67fb6bc7d3$var$getStatusCode = (error)=>(0, $2ASLw.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $a17a7c67fb6bc7d3$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $a17a7c67fb6bc7d3$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $a17a7c67fb6bc7d3$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $a17a7c67fb6bc7d3$export$bc96a6a479480590(error) {
    const statusCode = error && $a17a7c67fb6bc7d3$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $a17a7c67fb6bc7d3$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $fCrf0.getRandomTelemetryId)()
    } : undefined;
const $a17a7c67fb6bc7d3$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $a17a7c67fb6bc7d3$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$a17a7c67fb6bc7d3$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$a17a7c67fb6bc7d3$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $a17a7c67fb6bc7d3$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $3HtSd.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $a17a7c67fb6bc7d3$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $9Bvtr.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $a17a7c67fb6bc7d3$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$a17a7c67fb6bc7d3$export$eaf4479116d2f925(auth),
        ...$a17a7c67fb6bc7d3$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $a17a7c67fb6bc7d3$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $2ASLw.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$a17a7c67fb6bc7d3$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $a17a7c67fb6bc7d3$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $2ASLw.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$a17a7c67fb6bc7d3$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $a17a7c67fb6bc7d3$export$fee2242cbb339663 = (err)=>{
    const statusCode = $a17a7c67fb6bc7d3$var$getStatusCode(err);
    return $a17a7c67fb6bc7d3$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $a17a7c67fb6bc7d3$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $a17a7c67fb6bc7d3$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $2ASLw.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $a17a7c67fb6bc7d3$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$a17a7c67fb6bc7d3$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $a17a7c67fb6bc7d3$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $a17a7c67fb6bc7d3$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($a17a7c67fb6bc7d3$export$de0b576cf7ce4a53(err)) throw new (0, $2ASLw.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $2ASLw.isRequestError)(lastError)) throw $a17a7c67fb6bc7d3$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $2ASLw.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $a17a7c67fb6bc7d3$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $a17a7c67fb6bc7d3$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $a17a7c67fb6bc7d3$export$6397609af718d008(statusCode);
    return new (0, $2ASLw.RequestError)(reason, {
        ...metadata,
        ...$a17a7c67fb6bc7d3$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $a17a7c67fb6bc7d3$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $a17a7c67fb6bc7d3$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $a17a7c67fb6bc7d3$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}
module.exports["isFetchNetworkError"] = $a17a7c67fb6bc7d3$export$ad8c5cf7dd4c3caf;
module.exports["extendTraceContext"] = $a17a7c67fb6bc7d3$export$ee24a95986dfd173;
module.exports["createUrl"] = $a17a7c67fb6bc7d3$export$7138c24907de3954;
module.exports["extendHeaders"] = $a17a7c67fb6bc7d3$export$18cfbabc415d771c;
module.exports["createMapResponseToJson"] = $a17a7c67fb6bc7d3$export$e0519b126b73efa6;
module.exports["createMapResponseToBlob"] = $a17a7c67fb6bc7d3$export$5cc7b0795397da86;
module.exports["defaultShouldRetryError"] = $a17a7c67fb6bc7d3$export$fee2242cbb339663;
module.exports["fetchRetry"] = $a17a7c67fb6bc7d3$export$782df2acbe10b22c;
module.exports["createProcessFetchResponse"] = $a17a7c67fb6bc7d3$export$6e2e477edb7d6032;

});

parcelRegister("deNRp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dP5kx = parcelRequire("dP5kx");

const $afb57113d862e565$var$mediaApiPathPrefix = '/media-api';
function $afb57113d862e565$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $afb57113d862e565$export$6de3392754e98e65() {
    const isLocalhost = (0, $dP5kx.default)()?.location?.hostname === 'localhost';
    return (0, $dh538.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $afb57113d862e565$export$774e2add1fbe26aa(url) {
    if ($afb57113d862e565$export$6de3392754e98e65()) {
        const parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith($afb57113d862e565$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$afb57113d862e565$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
        const location = (0, $dP5kx.default)()?.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $afb57113d862e565$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $afb57113d862e565$export$e71b0af0000b3cfa(url) {
    const parsedUrl = new URL(url);
    parsedUrl.host = (0, $dP5kx.default)()?.location.host ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith($afb57113d862e565$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$afb57113d862e565$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
    return parsedUrl;
}
module.exports["isPathBasedEnabled"] = $afb57113d862e565$export$6de3392754e98e65;
module.exports["mapToPathBasedUrl"] = $afb57113d862e565$export$774e2add1fbe26aa;
module.exports["mapRetryUrlToPathBasedUrl"] = $afb57113d862e565$export$e71b0af0000b3cfa;

});

parcelRegister("eiASo", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");

class $fb17865681a916de$export$e3e60f0dab8641de extends (0, $dIgeg.BaseMediaClientError) {
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        // Legacy Attribute. Should be removed
        this.id = void 0;
        this.id = metadata.id;
    }
}
function $fb17865681a916de$export$5c3435f75ce0ce70(err) {
    return err instanceof $fb17865681a916de$export$e3e60f0dab8641de;
}
module.exports["FileFetcherError"] = $fb17865681a916de$export$e3e60f0dab8641de;

});

parcelRegister("2e4BA", function(module, exports) {
"use strict";
var $19f0761470c1d745$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4iRIL = parcelRequire("4iRIL");


var $YgydF = parcelRequire("YgydF");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $19f0761470c1d745$var$PromiseObservable = function(_super) {
    $19f0761470c1d745$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $4iRIL.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($19f0761470c1d745$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($19f0761470c1d745$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($19f0761470c1d745$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $4iRIL.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($YgydF.Observable);
module.exports.PromiseObservable = $19f0761470c1d745$var$PromiseObservable;
function $19f0761470c1d745$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $19f0761470c1d745$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});

parcelRegister("loLAD", function(module, exports) {
"use strict";
var $f940c139fd64c72d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $YgydF = parcelRequire("YgydF");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f940c139fd64c72d$var$RangeObservable = function(_super) {
    $f940c139fd64c72d$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($YgydF.Observable);
module.exports.RangeObservable = $f940c139fd64c72d$var$RangeObservable;

});

parcelRegister("jbEVV", function(module, exports) {
"use strict";
var $df7ecbebc32f3c75$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $df7ecbebc32f3c75$var$UnsubscriptionError = function(_super) {
    $df7ecbebc32f3c75$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $df7ecbebc32f3c75$var$UnsubscriptionError;

});

parcelRegister("1GCxN", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $13a79cc4b8b3af4b$export$77f77496d7cade10, (v) => $13a79cc4b8b3af4b$export$77f77496d7cade10 = v);
var $13a79cc4b8b3af4b$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $13a79cc4b8b3af4b$export$4a2e07ff24d010f0;
"use strict";

var $4iRIL = parcelRequire("4iRIL");

var $13a79cc4b8b3af4b$var$Symbol = $4iRIL.root.Symbol;
$13a79cc4b8b3af4b$export$77f77496d7cade10 = typeof $13a79cc4b8b3af4b$var$Symbol === 'function' && typeof $13a79cc4b8b3af4b$var$Symbol.for === 'function' ? $13a79cc4b8b3af4b$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$13a79cc4b8b3af4b$export$4a2e07ff24d010f0 = $13a79cc4b8b3af4b$export$77f77496d7cade10;

});

parcelRegister("1SUM9", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $15f6e009ebcff3b6$export$a6cdc56e425d0d0a, (v) => $15f6e009ebcff3b6$export$a6cdc56e425d0d0a = v);
var $15f6e009ebcff3b6$export$a6cdc56e425d0d0a;
"use strict";
function $15f6e009ebcff3b6$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$15f6e009ebcff3b6$export$a6cdc56e425d0d0a = $15f6e009ebcff3b6$var$isObject;

});

parcelRegister("lLPMj", function(module, exports) {
"use strict";
var $fd9626d5d45d22e9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $axeml = parcelRequire("axeml");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fd9626d5d45d22e9$var$InnerSubscriber = function(_super) {
    $fd9626d5d45d22e9$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($axeml.Subscriber);
module.exports.InnerSubscriber = $fd9626d5d45d22e9$var$InnerSubscriber;

});

parcelRegister("1v1oG", function(module, exports) {
$parcel$export(module.exports, "observable", () => $1179c51df4c90476$export$5ab46cbf6120b33a, (v) => $1179c51df4c90476$export$5ab46cbf6120b33a = v);
var $1179c51df4c90476$export$7e68bb2e8ecea8fe;
var $1179c51df4c90476$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $1179c51df4c90476$export$a7c40509ff863847;
"use strict";

var $4iRIL = parcelRequire("4iRIL");

function $1179c51df4c90476$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$1179c51df4c90476$export$7e68bb2e8ecea8fe = $1179c51df4c90476$var$getSymbolObservable;
$1179c51df4c90476$export$5ab46cbf6120b33a = $1179c51df4c90476$var$getSymbolObservable($4iRIL.root);
$1179c51df4c90476$export$a7c40509ff863847 = $1179c51df4c90476$export$5ab46cbf6120b33a;

});

parcelRegister("kmYd0", function(module, exports) {
$parcel$export(module.exports, "empty", () => $03d3afc1bef66cbf$export$6e22c362a0406a2c, (v) => $03d3afc1bef66cbf$export$6e22c362a0406a2c = v);
var $03d3afc1bef66cbf$export$6e22c362a0406a2c;
"use strict";
$03d3afc1bef66cbf$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("2RoPK", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $2153cb75c9c5c370$export$1e2f57719e155213, (v) => $2153cb75c9c5c370$export$1e2f57719e155213 = v);
var $2153cb75c9c5c370$export$1e2f57719e155213;
"use strict";
$2153cb75c9c5c370$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("lggQy", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $f7a829040e8b5b86$export$4369c812aac99591, (v) => $f7a829040e8b5b86$export$4369c812aac99591 = v);
var $f7a829040e8b5b86$export$4369c812aac99591;
"use strict";
function $f7a829040e8b5b86$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$f7a829040e8b5b86$export$4369c812aac99591 = $f7a829040e8b5b86$var$isPromise;

});

parcelRegister("ufz07", function(module, exports) {
"use strict";
var $05aee00ca103bae9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $4iRIL = parcelRequire("4iRIL");


var $YgydF = parcelRequire("YgydF");


var $kNaF1 = parcelRequire("kNaF1");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $05aee00ca103bae9$var$IteratorObservable = function(_super) {
    $05aee00ca103bae9$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $05aee00ca103bae9$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($YgydF.Observable);
module.exports.IteratorObservable = $05aee00ca103bae9$var$IteratorObservable;
var $05aee00ca103bae9$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$kNaF1.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $05aee00ca103bae9$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $05aee00ca103bae9$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$kNaF1.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $05aee00ca103bae9$var$getIterator(obj) {
    var i = obj[$kNaF1.iterator];
    if (!i && typeof obj === 'string') return new $05aee00ca103bae9$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $05aee00ca103bae9$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$kNaF1.iterator]();
}
var $05aee00ca103bae9$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $05aee00ca103bae9$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$05aee00ca103bae9$var$numberIsFinite(len)) return len;
    len = $05aee00ca103bae9$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $05aee00ca103bae9$var$maxSafeInteger) return $05aee00ca103bae9$var$maxSafeInteger;
    return len;
}
function $05aee00ca103bae9$var$numberIsFinite(value) {
    return typeof value === 'number' && $4iRIL.root.isFinite(value);
}
function $05aee00ca103bae9$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});

parcelRegister("lCIqm", function(module, exports) {
"use strict";
var $fbdf9b4b3e441b97$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $YgydF = parcelRequire("YgydF");


var $5OUhL = parcelRequire("5OUhL");


var $b5CQv = parcelRequire("b5CQv");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $fbdf9b4b3e441b97$var$ArrayLikeObservable = function(_super) {
    $fbdf9b4b3e441b97$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $b5CQv.EmptyObservable();
        else if (length === 1) return new $5OUhL.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($YgydF.Observable);
module.exports.ArrayLikeObservable = $fbdf9b4b3e441b97$var$ArrayLikeObservable;

});

parcelRegister("6rtaQ", function(module, exports) {
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $a16813b8a6dcc809$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $a16813b8a6dcc809$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $a16813b8a6dcc809$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $a16813b8a6dcc809$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $a16813b8a6dcc809$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $a16813b8a6dcc809$export$548d9148a80556a3 = (mimeType)=>$a16813b8a6dcc809$export$e9a065a80f76311e(mimeType) || $a16813b8a6dcc809$export$86baad7a89d908e9(mimeType) || $a16813b8a6dcc809$export$8cba23825d020bbb(mimeType) || $a16813b8a6dcc809$export$9c2b4de5fdca2ce3(mimeType) || $a16813b8a6dcc809$export$94e1479e01d2af53(mimeType);
module.exports["isImageMimeTypeSupportedByServer"] = $a16813b8a6dcc809$export$e9a065a80f76311e;
module.exports["isDocumentMimeTypeSupportedByServer"] = $a16813b8a6dcc809$export$86baad7a89d908e9;
module.exports["isAudioMimeTypeSupportedByServer"] = $a16813b8a6dcc809$export$8cba23825d020bbb;
module.exports["isVideoMimeTypeSupportedByServer"] = $a16813b8a6dcc809$export$9c2b4de5fdca2ce3;
module.exports["isMimeTypeSupportedByServer"] = $a16813b8a6dcc809$export$548d9148a80556a3;

});

parcelRegister("74JhH", function(module, exports) {
"use strict";
var $526c08aa7ed04c75$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $k8JsH = parcelRequire("k8JsH");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $526c08aa7ed04c75$var$QueueAction = function(_super) {
    $526c08aa7ed04c75$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($k8JsH.AsyncAction);
module.exports.QueueAction = $526c08aa7ed04c75$var$QueueAction;

});

parcelRegister("1qr9n", function(module, exports) {
"use strict";
var $109d47a3a3735f2f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $iOeLv = parcelRequire("iOeLv");

var $109d47a3a3735f2f$var$QueueScheduler = function(_super) {
    $109d47a3a3735f2f$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($iOeLv.AsyncScheduler);
module.exports.QueueScheduler = $109d47a3a3735f2f$var$QueueScheduler;

});

parcelRegister("lQpfG", function(module, exports) {
"use strict";
var $fe720acac5c4704e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8v4h5 = parcelRequire("8v4h5");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe720acac5c4704e$var$SubjectSubscription = function(_super) {
    $fe720acac5c4704e$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($8v4h5.Subscription);
module.exports.SubjectSubscription = $fe720acac5c4704e$var$SubjectSubscription;

});

parcelRegister("47xz6", function(module, exports) {
"use strict";
var $3001da32478ae63c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8v4h5 = parcelRequire("8v4h5");

/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $3001da32478ae63c$var$Action = function(_super) {
    $3001da32478ae63c$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($8v4h5.Subscription);
module.exports.Action = $3001da32478ae63c$var$Action;

});

parcelRegister("jcSqS", function(module, exports) {
const $fa328acec36e2257$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["getVideoDimensionsFromBlob"] = $fa328acec36e2257$export$62aabd5ff85d0451;

});

parcelRegister("2WUwQ", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");

class $9af068d807b4bf0c$export$c3748c310e92340a extends (0, $dIgeg.BaseMediaClientError) {
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
}
function $9af068d807b4bf0c$export$541e3e52eea6fece(err) {
    return err instanceof $9af068d807b4bf0c$export$c3748c310e92340a;
}
module.exports["PollingError"] = $9af068d807b4bf0c$export$c3748c310e92340a;

});

parcelRegister("eUfuX", function(module, exports) {
var $2faae3982500ccd8$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/middleware.mjs"
});
const $2faae3982500ccd8$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $2faae3982500ccd8$export$4feba8a1bc8e9afd = $2faae3982500ccd8$var$reduxImpl;
const $2faae3982500ccd8$var$trackedConnections = /* @__PURE__ */ new Map();
const $2faae3982500ccd8$var$getTrackedConnectionState = (name)=>{
    const api = $2faae3982500ccd8$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $2faae3982500ccd8$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $2faae3982500ccd8$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $2faae3982500ccd8$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $2faae3982500ccd8$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($2faae3982500ccd8$import_meta.env ? $2faae3982500ccd8$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($2faae3982500ccd8$import_meta.env ? $2faae3982500ccd8$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $2faae3982500ccd8$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$2faae3982500ccd8$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($2faae3982500ccd8$import_meta.env ? $2faae3982500ccd8$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $2faae3982500ccd8$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($2faae3982500ccd8$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($2faae3982500ccd8$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $2faae3982500ccd8$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($2faae3982500ccd8$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $2faae3982500ccd8$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $2faae3982500ccd8$export$6922d3b3a607469e = $2faae3982500ccd8$var$devtoolsImpl;
const $2faae3982500ccd8$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $2faae3982500ccd8$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $2faae3982500ccd8$export$5c593627aef9f076 = $2faae3982500ccd8$var$subscribeWithSelectorImpl;
const $2faae3982500ccd8$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $2faae3982500ccd8$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $2faae3982500ccd8$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $2faae3982500ccd8$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $2faae3982500ccd8$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $2faae3982500ccd8$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $2faae3982500ccd8$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $2faae3982500ccd8$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $2faae3982500ccd8$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $2faae3982500ccd8$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $2faae3982500ccd8$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $2faae3982500ccd8$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($2faae3982500ccd8$import_meta.env ? $2faae3982500ccd8$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $2faae3982500ccd8$var$oldImpl(config, baseOptions);
    }
    return $2faae3982500ccd8$var$newImpl(config, baseOptions);
};
const $2faae3982500ccd8$export$9a6132153fba2e0 = $2faae3982500ccd8$var$persistImpl;



var $foB1g = parcelRequire("foB1g");

const $370a3b99977bf01a$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $foB1g.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $370a3b99977bf01a$export$428de7ec69ac95c = $370a3b99977bf01a$var$immerImpl;



var $9mu1x = parcelRequire("9mu1x");

const $5a7d534c182a9417$var$mediaStoreWithoutDevtools = (0, $9mu1x.createStore)()((0, $2faae3982500ccd8$export$5c593627aef9f076)((0, $370a3b99977bf01a$export$428de7ec69ac95c)(()=>({
        files: {}
    }))));
const $5a7d534c182a9417$var$mediaStoreWithDevtools = (0, $9mu1x.createStore)()((0, $2faae3982500ccd8$export$6922d3b3a607469e)((0, $2faae3982500ccd8$export$5c593627aef9f076)((0, $370a3b99977bf01a$export$428de7ec69ac95c)(()=>({
        files: {}
    })))));
const $5a7d534c182a9417$export$5785580dea19518d = $5a7d534c182a9417$var$mediaStoreWithoutDevtools;
const $5a7d534c182a9417$export$503459913a0dc356 = (initialStore)=>{
    return (0, $9mu1x.createStore)()((0, $2faae3982500ccd8$export$5c593627aef9f076)((0, $370a3b99977bf01a$export$428de7ec69ac95c)(()=>({
            files: {},
            ...initialStore
        }))));
};
module.exports["mediaStore"] = $5a7d534c182a9417$export$5785580dea19518d;

});

parcelRegister("57XaE", function(module, exports) {
function $34601803eee2771e$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}
module.exports["isCommercial"] = $34601803eee2771e$export$df69ff6733e73e50;

});

parcelRegister("942a0", function(module, exports) {
/**
 * Returns true if the current hostname matches the GCP tenant pattern.
 * GCP tenants follow the pattern: <name>-cdp-<cdp-id>.jira-dev.com
 *
 * CDN (CloudFront) is an AWS service and is not available on GCP tenants.
 * This function is used to gate CDN delivery, mirroring the isIsolatedCloud() pattern.
 *
 * @param hostname - Optional hostname override (defaults to globalThis.location?.hostname). Used for testing.
 */ function $c9c5563eb64d8c9a$export$1e98abd71682b665(hostname) {
    const host = hostname ?? (typeof globalThis !== 'undefined' ? globalThis.location?.hostname : undefined);
    if (!host) return false;
    const gcpTenantPattern = /^.*-cdp-\w+\.jira-dev\.com$/;
    return gcpTenantPattern.test(host);
}
module.exports["isGCPtenant"] = $c9c5563eb64d8c9a$export$1e98abd71682b665;

});

parcelRegister("9Bvtr", function(module, exports) {
parcelRequire("5vzpD");
var $3HtSd = parcelRequire("3HtSd");

function $81f09d982bc1e00c$export$6833b130611df767(auth) {
    if ((0, $3HtSd.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}
module.exports["mapAuthToQueryParameters"] = $81f09d982bc1e00c$export$6833b130611df767;

});

parcelRegister("dP5kx", function(module, exports) {
$parcel$export(module.exports, "default", () => $40149d90e5f05585$export$2e2bcd8739ae039);
var $40149d90e5f05585$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


$parcel$global.rlb("6edij")
//# sourceMappingURL=preloadables.591000e6.js.map
